webpackJsonp([1],{

/***/ "+F7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_path__ = __webpack_require__("SeUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Checkbox__ = __webpack_require__("LgiA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-item',
  props: ['value', 'node', 'errors', 'path', 'errorsPaths'],
  data: function data() {
    return {
      expanded: this.isExpanded()
    };
  },

  components: {
    CCheckbox: __WEBPACK_IMPORTED_MODULE_1__lib_components_Checkbox__["a" /* default */]
  },
  computed: {
    isSelected: function isSelected() {
      return this.isExpanded();
    },

    enabledData: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0_object_path___default.a.get(this.value, this.node.enabledPath);
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_0_object_path___default.a.set(this.value, this.node.enabledPath, value);
      }
    },
    hasChildren: function hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    hasFields: function hasFields() {
      return this.node.enabledPath || this.node.fields && this.node.fields.length > 0;
    },
    hasError: function hasError() {
      return this.hasErrorInNode(this.node);
    }
  },
  methods: {
    hasErrorInNode: function hasErrorInNode(node) {
      var _this = this;

      if (node.children && node.children.length > 0) {
        return node.children.some(function (node) {
          return _this.hasErrorInNode(node);
        });
      }

      if (node.fields && node.fields.length > 0) {
        return node.fields.some(function (field) {
          return _this.hasErrorInField(field);
        });
      }

      return false;
    },
    hasErrorInField: function hasErrorInField(field) {
      var _this2 = this;

      if (field.fields && field.fields.length > 0) {
        return field.fields.some(function (field) {
          return _this2.hasErrorInField(field);
        });
      }

      return this.errorsPaths.some(function (path) {
        return field.path === path;
      });
    },
    toggleOrClick: function toggleOrClick() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
      } else {
        if (this.hasFields) {
          var hash = this.path.join('/');
          this.$router.push('#' + hash);
        }
      }
    },
    isExpanded: function isExpanded() {
      var hash = (this.$route.hash.slice(1) || 'general').split('/');
      return this.path.every(function (item, i) {
        return item === hash[i];
      });
    }
  }
});

/***/ }),

/***/ "/KV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/QNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("hz3K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54761672_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("r0Jc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("LKdc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54761672_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54761672_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/jhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.field.label)?_c('b-field',{staticClass:"field",attrs:{"horizontal":"","label":_vm.field.label,"type":_vm.hasError ? 'is-danger' : '',"message":_vm.errorMessage}},[_c(_vm.field.type,{tag:"component",attrs:{"type":_vm.field.valueType,"fieldErrors":_vm.fieldErrors,"fieldPayload":_vm.fieldPayload},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1):_c(_vm.field.type,{tag:"component",attrs:{"type":_vm.field.valueType,"fieldErrors":_vm.fieldErrors,"fieldPayload":_vm.fieldPayload},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []


/***/ }),

/***/ "0vwc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1g9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2/wf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagInput_vue__ = __webpack_require__("27qI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72696640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagInput_vue__ = __webpack_require__("uSoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72696640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72696640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "27qI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-tag-input',
  props: ['value'],
  computed: {
    data: {
      get: function get() {
        var value = Array.isArray(this.value) ? this.value : [];
        return value.map(function (v) {
          return v.data;
        });
      },
      set: function set(value) {
        this.$emit('input', value.map(function (v) {
          return { data: v };
        }));
      }
    }
  }
});

/***/ }),

/***/ "2Hui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__ = __webpack_require__("gGau");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      list: [],
      loading: false
    };
  },

  components: {
    empty: __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__["a" /* default */]
  },
  methods: {
    load: function load() {
      var _this = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('partners').then(function (resp) {
        return _this.list = resp.data;
      }).catch(function () {}).then(function () {
        return _this.loading = false;
      });
    },
    remove: function remove() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].delete('partners').then(function () {
        return _this2.load();
      }).catch(function () {}).then(function () {
        return _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "2yOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("Vi6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d49648_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("iPiz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d49648_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d49648_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4WnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  '1': {
    migration: [{ op: 'add', path: '/version', value: 1 }, { op: 'add', path: '/indexRoute', value: 'prelive' }, { op: 'add', path: '/login.termsCheck', value: false }, { op: 'add', path: '/registration.type', value: 'basic' }, { op: 'add', path: '/registration.passwordStrength', value: 'low' }, { op: 'add', path: '/translations.api', value: 'https://i18n.bettings.ch' }, { op: 'add', path: '/translations.token', value: '' }, { op: 'add', path: '/sportsbook.live.source', value: 0 }, { op: 'add', path: '/sportsbook.prelive.source', value: 0 }, { op: 'add', path: '/sportsbook.betslip.parlayLimit', value: 20 }, { op: 'add', path: '/sportsbook.betslip.doubleChanceLimit', value: true }, { op: 'add', path: '/competition.source', value: 0 }, { op: 'add', path: '/exchange.source', value: 0 }, { op: 'add', path: '/sessionGames.adminToken', value: '' }, { op: 'add', path: '/exchanges.bets.defaults.enabled', value: false }, { op: 'add', path: '/exchanges.bets.quick.enabled', value: false }, { op: 'add', path: '/exchanges.bets.confirm.enabled', value: true }, { op: 'add', path: '/exchanges.bets.confirm.default', value: true }, { op: 'add', path: '/exchanges.markets.open.count', value: 4 }, { op: 'add', path: '/exchanges.multimarkets.enabled', value: true }, { op: 'add', path: '/exchanges.lowLiquidityCheck.enabled', value: false }, { op: 'add', path: '/exchanges.lowLiquidityCheck.minTotalMatched', value: 5000 }, { op: 'add', path: '/exchanges.lowLiquidityCheck.minTotalAvailable', value: 500 }, { op: 'add', path: '/exchanges.realLiquidity.show', value: false }, { op: 'add', path: '/btsAdmin.url', value: 'https://dev.bts-admin.bettings.ch' }, { op: 'add', path: '/services.recaptcha.key', value: '' }, { op: 'add', path: '/services.googleAnalytics.key', value: '' }, { op: 'add', path: '/services.affiliateSystem.enabled', value: false }]
  },
  '2': {
    migration: [{ op: 'replace', path: '/version', value: 2 }, { op: 'add', path: '/permissions', value: {} }]
  },
  '3': {
    migration: [{ op: 'replace', path: '/version', value: 3 }, { op: 'remove', path: '/services.affiliateSystem.enabled' }]
  },
  '4': {
    migration: [{ op: 'replace', path: '/version', value: 4 }]
  },
  '5': {
    migration: [{ op: 'replace', path: '/version', value: 5 }, { op: 'add', path: '/sportsbook.sources', value: [] }, { op: 'remove', path: '/sportsbook.live.source' }, { op: 'remove', path: '/sportsbook.prelive.source' }]
  },
  '6': {
    migration: [{ op: 'replace', path: '/version', value: 6 }, { op: 'add', path: '/theme', value: '24betting' }]
  },
  '7': {
    migration: [{ op: 'replace', path: '/version', value: 7 }, {
      op: 'add',
      path: '/user.fields',
      value: {
        username: { registration: true, account: true, required: true, editable: false },
        password: { registration: true, account: true, required: true, editable: false },
        gender: { registration: true, account: true, required: true, editable: false },
        firstName: { registration: true, account: true, required: true, editable: false },
        lastName: { registration: true, account: true, required: true, editable: false },
        birthday: { registration: true, account: true, required: true, editable: false },
        currency: { registration: true, account: true, required: true, editable: false },
        code: { registration: false, account: true, required: false, editable: false },
        country: { registration: true, account: true, required: true, editable: false },
        city: { registration: true, account: true, required: true, editable: false },
        zip: { registration: true, account: true, required: true, editable: false },
        street: { registration: true, account: true, required: true, editable: false },
        email: { registration: true, account: true, required: true, editable: false },
        phone: { registration: true, account: true, required: true, editable: true },
        acceptTerms: { registration: true, account: true, required: true, editable: false }
      }
    }]
  },
  '8': {
    migration: [{ op: 'replace', path: '/version', value: 8 }, { op: 'add', path: '/verification.notification', value: false }, { op: 'add', path: '/sessionGames.automateGames', value: false }, { op: 'add', path: '/currencies.visible', value: true }],
    update: function update(data, stage) {
      switch (stage) {
        case 'dev':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { 'btsAdmin.url': 'https://dev.bts-admin.bettings.ch' });
        case 'prod':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { 'btsAdmin.url': 'https://bts-admin.bettings.ch' });
      }
    }
  },
  '9': {
    migration: [{ op: 'replace', path: '/version', value: 9 }],
    update: function update(data, stage) {
      switch (stage) {
        case 'dev':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { 'bts.printUrl': 'https://dev.sbpdf.bettings.ch' });
        case 'prod':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { 'bts.printUrl': 'https://sbpdf.bettings.ch' });
      }
    }
  },
  '10': {
    migration: [{ op: 'replace', path: '/version', value: 10 }],
    update: function update(data, stage) {
      var devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'competition.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'dabba.api': 'https://dev.dabbaexch.bettings.ch/api/',
        'betfair.api': 'https://dev.bfgw.bettings.ch/api/',
        'sessionGames.api': 'https://dev.sgapi.bettings.ch/',
        'matchbook.api': 'https://dev.mbgw.bettings.ch/edge/rest/'
      };

      var prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api/v2',
        'exchange.api': 'https://sbapi.bettings.ch/api/v2',
        'competition.api': 'https://sbapi.bettings.ch/api/v2',
        'dabba.api': 'https://dabbaexch.bettings.ch/api/',
        'betfair.api': 'https://api.betsoho.com/api/',
        'sessionGames.api': 'https://sgapi.bettings.ch',
        'matchbook.api': 'https://mbgw.bettings.ch/edge/rest/'
      };

      switch (stage) {
        case 'dev':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, devAPI);
        case 'prod':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, prodAPI);
      }
    }
  },
  '11': {
    migration: [{ op: 'replace', path: '/version', value: 11 }, { op: 'replace', path: '/sessionGames.automateGames', value: true }]
  },
  '12': {
    migration: [{ op: 'replace', path: '/version', value: 12 }],
    update: function update(data, stage) {
      var devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api/',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api/',
        'competition.api': 'https://dev.sbapi.bettings.ch/api/'
      };

      var prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api/',
        'exchange.api': 'https://sbapi.bettings.ch/api/',
        'competition.api': 'https://sbapi.bettings.ch/api/'
      };

      switch (stage) {
        case 'dev':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, devAPI);
        case 'prod':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, prodAPI);
      }
    }
  },
  '13': {
    migration: [{ op: 'replace', path: '/version', value: 13 }],
    update: function update(data, stage) {
      var devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api',
        'competition.api': 'https://dev.sbapi.bettings.ch/api',
        'dabba.api': 'https://dev.dabbaexch.bettings.ch/api',
        'betfair.api': 'https://dev.bfgw.bettings.ch/api',
        'sessionGames.api': 'https://dev.sgapi.bettings.ch',
        'matchbook.api': 'https://dev.mbgw.bettings.ch/edge/rest'
      };

      var prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api',
        'exchange.api': 'https://sbapi.bettings.ch/api',
        'competition.api': 'https://sbapi.bettings.ch/api',
        'dabba.api': 'https://dabbaexch.bettings.ch/api',
        'betfair.api': 'https://api.betsoho.com/api',
        'sessionGames.api': 'https://sgapi.bettings.ch',
        'matchbook.api': 'https://mbgw.bettings.ch/edge/rest'
      };

      switch (stage) {
        case 'dev':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, devAPI);
        case 'prod':
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, prodAPI);
      }
    }
  },
  '14': {
    migration: [{ op: 'replace', path: '/version', value: 14 }, { op: 'add', path: '/login.required', value: false }]
  },
  '15': {
    migration: [{ op: 'replace', path: '/version', value: 15 }, { op: 'add', path: '/poolbetting.api', value: '' }, { op: 'add', path: '/poolbetting.adminToken', value: '' }]
  },
  '16': {
    migration: [{ op: 'replace', path: '/version', value: 16 }, {
      op: 'move',
      from: '/exchanges.lowLiquidityCheck.enabled',
      path: '/betfair.lowLiquidityCheck.enabled'
    }, {
      op: 'move',
      from: '/exchanges.lowLiquidityCheck.minTotalMatched',
      path: '/betfair.lowLiquidityCheck.minTotalMatched'
    }, {
      op: 'move',
      from: '/exchanges.lowLiquidityCheck.minTotalAvailable',
      path: '/betfair.lowLiquidityCheck.minTotalAvailable'
    }]
  },
  '17': {
    migration: [{ op: 'replace', path: '/version', value: 17 }, { op: 'add', path: '/oneClickBetting.enabled', value: false }, { op: 'add', path: '/matchbook.showLiquidityEverywhere', value: true }, { op: 'add', path: '/betfair.showLiquidityEverywhere', value: true }, { op: 'add', path: '/exchange.showLiquidityEverywhere', value: true }]
  },
  '18': {
    migration: [{ op: 'replace', path: '/version', value: 18 },
    // betfair
    { op: 'add', path: '/betfair.prefixUrl', value: '/exchange' }, { op: 'add', path: '/betfair.prelive.enabled', value: true }, { op: 'add', path: '/betfair.prelive.title', value: 'Home' }, { op: 'add', path: '/betfair.live.enabled', value: true }, { op: 'add', path: '/betfair.live.title', value: 'Inplay' },
    // dabba
    { op: 'add', path: '/dabba.prefixUrl', value: '/exchange' }, { op: 'add', path: '/dabba.prelive.enabled', value: true }, { op: 'add', path: '/dabba.prelive.title', value: 'Home' }, { op: 'add', path: '/dabba.live.enabled', value: true }, { op: 'add', path: '/dabba.live.title', value: 'Inplay' }, { op: 'add', path: '/dabba.showLiquidityEverywhere', value: true },
    // exchange
    { op: 'add', path: '/exchange.prefixUrl', value: '/exchange' }, { op: 'add', path: '/exchange.prelive.enabled', value: true }, { op: 'add', path: '/exchange.prelive.title', value: 'Home' }, { op: 'add', path: '/exchange.live.enabled', value: true }, { op: 'add', path: '/exchange.live.title', value: 'Inplay' },
    // matchbook
    { op: 'add', path: '/matchbook.prefixUrl', value: '/exchange' }, { op: 'add', path: '/matchbook.prelive.enabled', value: true }, { op: 'add', path: '/matchbook.prelive.title', value: 'Home' }, { op: 'add', path: '/matchbook.live.enabled', value: true }, { op: 'add', path: '/matchbook.live.title', value: 'Inplay' }]
  },
  '19': {
    migration: [{ op: 'replace', path: '/version', value: 19 }, { op: 'remove', path: '/exchange.source' }, { op: 'remove', path: '/exchange.prefixUrl' }, { op: 'remove', path: '/exchange.prelive.enabled' }, { op: 'remove', path: '/exchange.prelive.title' }, { op: 'remove', path: '/exchange.live.enabled' }, { op: 'remove', path: '/exchange.live.title' }, { op: 'add', path: '/exchange.sources', value: [] }]
  },
  '20': {
    migration: [{ op: 'replace', path: '/version', value: 20 }, { op: 'add', path: '/responsibleGambling', value: false }]
  },
  '21': {
    migration: [{ op: 'replace', path: '/version', value: 21 }, { op: 'add', path: '/displayCurrency', value: true }]
  },
  '22': {
    migration: [{ op: 'replace', path: '/version', value: 22 }, { op: 'add', path: '/streak.api', value: '' }, { op: 'add', path: '/streak.token', value: '' }]
  },
  '23': {
    migration: [{ op: 'replace', path: '/version', value: 23 }, { op: 'add', path: '/sportsbook.betslip.maxStake', value: false }]
  },
  '24': {
    migration: [{ op: 'replace', path: '/version', value: 24 }, { op: 'add', path: '/betfair.betslip.submitDelay', value: 0 }, { op: 'add', path: '/dabba.betslip.submitDelay', value: 0 }, { op: 'add', path: '/matchbook.betslip.submitDelay', value: 0 }, { op: 'add', path: '/exchange.betslip.submitDelay', value: 0 }, { op: 'add', path: '/sessionGames.betslip.submitDelay', value: 0 }, { op: 'add', path: '/sportsbook.betslip.submitDelay', value: 0 }, { op: 'add', path: '/poolbetting.betslip.submitDelay', value: 0 }]
  },
  '25': {
    migration: [{ op: 'replace', path: '/version', value: 25 }, { op: 'add', path: '/neverBounce.apiKey', value: '' }]
  },
  '26': {
    migration: [{ op: 'add', path: '/intercom.publicAppId', value: '' }, { op: 'add', path: '/intercom.options', value: [] }]
  },
  '27': {
    migration: [{ op: 'add', path: '/widgets.matchProgress', value: '' }]
  },
  '28': {
    migration: [{ op: 'add', path: '/moneyTransfer.enabled', value: false }]
  }
});

/***/ }),

/***/ "5QiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"sentiment_very_dissatisfied","size":"is-large"}})],1),_vm._v(" "),_c('p',[_vm._v("Nothing here.")])])])}
var staticRenderFns = []


/***/ }),

/***/ "5hOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-switch',
  props: ['value']
});

/***/ }),

/***/ "5kAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('button',{staticClass:"button field is-primary pull-right",on:{"click":_vm.create}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" "),_c('span',[_vm._v("New")])],1),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.providers,"loading":_vm.loading,"striped":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Name","field":"name"}},[_vm._v("\n        "+_vm._s(props.row.name)+"\n      ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Actions","width":200}},[_c('router-link',{attrs:{"to":("/providers/" + (props.row.id) + "/edit")}},[_c('button',{staticClass:"button"},[_vm._v("Edit")])]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){$event.preventDefault();_vm.remove(props.row.id, props.index)}}},[_vm._v("Remove")])],1)]}}])},[(!_vm.loading)?_c('template',{slot:"empty"},[_c('empty')],1):_vm._e()],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "6BGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_path__ = __webpack_require__("SeUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Switch__ = __webpack_require__("Mddy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Field__ = __webpack_require__("Eqli");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fields',
  props: ['value', 'errors', 'node'],
  components: {
    CSwitch: __WEBPACK_IMPORTED_MODULE_1__lib_components_Switch__["a" /* default */],
    Field: __WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */]
  },
  computed: {
    enabledData: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0_object_path___default.a.get(this.value, this.node.enabledPath);
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_0_object_path___default.a.set(this.value, this.node.enabledPath, value);
      }
    }
  }
});

/***/ }),

/***/ "6c7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-select',
  props: ['value']
});

/***/ }),

/***/ "7302":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = humanize;
/* unused harmony export capitalize */
function humanize(value) {
  return value.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').replace(/(\w+)/g, capitalize);
}

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/***/ }),

/***/ "7m8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function pick(arr, obj) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).reduce(function (acc, key) {
    if (arr.indexOf(key) === -1) return acc;
    acc[key] = obj[key];
    return acc;
  }, {});
}

/***/ }),

/***/ "7v74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment-paysec-currencies-wallets',
  props: ['value', 'fieldErrors', 'fieldPayload']
});

/***/ }),

/***/ "8XDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = error;
/* harmony export (immutable) */ __webpack_exports__["b"] = success;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var errorDefaults = {
  duration: 5000,
  message: 'Something is wrong. Try to enter correct data.',
  position: 'is-bottom'
};

var successDefaults = {
  duration: 5000,
  message: 'Success',
  position: 'is-bottom'
};

function error() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, errorDefaults, settings, { type: 'is-danger' });
}

function success() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, successDefaults, settings, { type: 'is-success' });
}

/***/ }),

/***/ "9NKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intercom-options',
  props: ['value'],
  computed: {
    data: function data() {
      return this.value || [];
    }
  }
});

/***/ }),

/***/ "9zY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DuplicateForm_vue__ = __webpack_require__("vjwh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1065ba6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DuplicateForm_vue__ = __webpack_require__("bniC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DuplicateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1065ba6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DuplicateForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1065ba6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DuplicateForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A3Pa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__ = __webpack_require__("eEJf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6408d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__ = __webpack_require__("nrEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("LLfw")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6408d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6408d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bulm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__ = __webpack_require__("+F7m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c66e2dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__ = __webpack_require__("LE1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0vwc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c66e2dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c66e2dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c66e2dd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C4H2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"toolbar"},[_c('button',{staticClass:"button field is-primary",on:{"click":_vm.create}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" "),_c('span',[_vm._v("New")])],1),_vm._v(" "),_c('b-input',{staticClass:"search-input",attrs:{"type":"search","placeholder":"Search","autofocus":'autofocus'},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}})],1),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.filteredProjects,"loading":_vm.loading,"striped":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Name"}},[_c('router-link',{attrs:{"to":("/projects/" + (props.row.id) + "/edit")}},[_vm._v(_vm._s(props.row.name))])],1),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Enabled","centered":""}},[_c('a',{class:['button', 'enable-button',
            props.row.enabled ? 'is-success' : 'is-danger',
            { 'is-loading': _vm.togglingProjectId === props.row.id }],on:{"click":function($event){$event.preventDefault();_vm.toggleEnable(props.row.id)}}},[_vm._v(_vm._s(props.row.enabled ? 'Yes' : 'No'))])]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Domains"}},[_vm._v(_vm._s(props.row.domain.join(', ')))]),_vm._v(" "),_c('b-table-column',{attrs:{"width":300}},[_c('a',{attrs:{"href":("http://" + (props.row.domain[0]) + "/initialize"),"target":"_blank"}},[_c('button',{staticClass:"button"},[_vm._v("Initialize")])]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.flushCache(props.row.domain[0])}}},[_c('button',{staticClass:"button"},[_vm._v("Flush Cache")])]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.flushGameCache(props.row.domain[0])}}},[_c('button',{staticClass:"button"},[_vm._v("Flush Game Cache")])]),_vm._v(" "),_c('router-link',{attrs:{"to":("/projects/" + (props.row.id) + "/edit")}},[_c('button',{staticClass:"button"},[_vm._v("Edit")])]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.toggleDuplicateModal(props.row.id)}}},[_vm._v("Duplicate")])],1)]}}])},[(!_vm.loading)?_c('template',{slot:"empty"},[_c('empty')],1):_vm._e()],2),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.isDuplicateModalOpened,"has-modal-card":""},on:{"update:active":function($event){_vm.isDuplicateModalOpened=$event}}},[_c('duplicate-form',{attrs:{"projectId":_vm.duplicatedProjectId}})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "CHsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.node)?_c('section',[(_vm.node.enabledPath)?_c('div',[_c('b-field',{attrs:{"horizontal":"","label":"Enabled"}},[_c('c-switch',{model:{value:(_vm.enabledData),callback:function ($$v) {_vm.enabledData=$$v},expression:"enabledData"}})],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.node.fields),function(field){return _c('div',{key:field.label},[(field.fields)?_c('fieldset',[_c('legend',{staticClass:"label"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('fields',{attrs:{"node":field,"errors":_vm.errors},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_c('field',{attrs:{"errors":_vm.errors,"field":field},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)})],2):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "DeWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileManager_vue__ = __webpack_require__("uWZR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe4b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileManager_vue__ = __webpack_require__("F7px");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe4b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileManager_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe4b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileManager_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EVTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._l((_vm.data),function(item,index){return _c('b-field',{key:index,staticStyle:{"margin-bottom":"5px","margin-top":"20px","flex-direction":"column","flex-wrap":"wrap"}},[_vm._l((item),function(itemField,index){return _c('b-field',{key:index,staticStyle:{"margin-right":"5px","margin-left":"5px","margin-top":"5px"}},[_vm._v("\n      "+_vm._s(index)+"\n      "),_c('b-input',{attrs:{"expanded":""},model:{value:(itemField.data),callback:function ($$v) {_vm.$set(itemField, "data", $$v)},expression:"itemField.data"}})],1)}),_vm._v(" "),_c('div',{staticStyle:{"align-self":"flex-end"}},[_c('button',{staticClass:"button is-primary",staticStyle:{"margin-top":"10px","margin-right":"5px","align-self":"flex-end"},attrs:{"type":"button"},on:{"click":function($event){_vm.remove(index)}}},[_vm._v("\n        Remove\n      ")])])],2)}),_vm._v(" "),_c('b-field',[_c('button',{staticClass:"button is-primary",staticStyle:{"margin-top":"15px"},attrs:{"type":"button"},on:{"click":_vm.add}},[_c('b-icon',{attrs:{"icon":"plus","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v("Add")])],1)])],2)}
var staticRenderFns = []


/***/ }),

/***/ "EVno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiInput_vue__ = __webpack_require__("Mq2U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503267cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiInput_vue__ = __webpack_require__("SwOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503267cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503267cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ElPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-field',
  props: ['value', 'type'],
  computed: {
    valueIsObj: function valueIsObj() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value) === 'object';
    }
  },
  methods: {
    onInput: function onInput(value) {
      switch (this.type) {
        case 'integer':
          this.$emit('input', parseInt(value));
          break;
        default:
          this.$emit('input', value);
      }
    }
  }
});

/***/ }),

/***/ "Eqli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__ = __webpack_require__("fw3t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e437d6c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__ = __webpack_require__("/jhe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("vsZp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e437d6c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e437d6c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F2SA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.rows.length)?_c('table',{staticClass:"table is-striped"},[_c('thead',[_c('th',[_vm._v("Currency")]),_vm._v(" "),_vm._l((_vm.columns),function(col){return _c('th',{key:col.key},[_vm._v(_vm._s(col.label))])}),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row,index){return _c('tr',{key:index},[_c('td',[_c('b-select',{attrs:{"disabled":_vm.isLocked(row),"placeholder":"Currency"},model:{value:(row.currency.data),callback:function ($$v) {_vm.$set(row.currency, "data", $$v)},expression:"row.currency.data"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Currency")]),_vm._v(" "),_vm._l((_vm.currencyChoices),function(choice){return _c('option',{key:choice.value,domProps:{"value":choice.value}},[_vm._v("\n              "+_vm._s(choice.label)+"\n            ")])})],2)],1),_vm._v(" "),_vm._l((_vm.columns),function(col){return _c('td',{key:col.key},[_c('b-input',{model:{value:(row[col.key].data),callback:function ($$v) {_vm.$set(row[col.key], "data", $$v)},expression:"row[col.key].data"}})],1)}),_vm._v(" "),_c('td',[(!_vm.isLocked(row))?_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('b-icon',{attrs:{"icon":"minus"}})],1):_vm._e()])],2)}))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":_vm.addRow}},[_c('b-icon',{attrs:{"icon":"plus"}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ "F5yq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F7px":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-field',{attrs:{"label":"Type","horizontal":""}},[_c('c-select',{model:{value:(_vm.value.type),callback:function ($$v) {_vm.$set(_vm.value, "type", $$v)},expression:"value.type"}})],1),_vm._v(" "),(_vm.value.type.data === 's3')?[_c('b-field',{attrs:{"label":"Key","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.s3_key),callback:function ($$v) {_vm.$set(_vm.value, "s3_key", $$v)},expression:"value.s3_key"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Secret","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.s3_secret),callback:function ($$v) {_vm.$set(_vm.value, "s3_secret", $$v)},expression:"value.s3_secret"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Bucket","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.s3_bucket),callback:function ($$v) {_vm.$set(_vm.value, "s3_bucket", $$v)},expression:"value.s3_bucket"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Region","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.s3_region),callback:function ($$v) {_vm.$set(_vm.value, "s3_region", $$v)},expression:"value.s3_region"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Version","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.s3_version),callback:function ($$v) {_vm.$set(_vm.value, "s3_version", $$v)},expression:"value.s3_version"}})],1)]:(_vm.value.type.data === 'local')?[_c('b-field',{attrs:{"label":"Public Dir","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.local_public_dir),callback:function ($$v) {_vm.$set(_vm.value, "local_public_dir", $$v)},expression:"value.local_public_dir"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Private Dir","horizontal":""}},[_c('c-input',{model:{value:(_vm.value.local_private_dir),callback:function ($$v) {_vm.$set(_vm.value, "local_private_dir", $$v)},expression:"value.local_private_dir"}})],1)]:_vm._e()],2)}
var staticRenderFns = []


/***/ }),

/***/ "FRx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'frontend-registration-type',
  props: ['value'],
  data: function data() {
    return {
      choices: ['basic', 'agent']
    };
  }
});

/***/ }),

/***/ "Fa6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bonus-currency-map',
  props: ['value', 'fieldErrors', 'fieldPayload', 'type'],
  computed: {
    rows: function rows() {
      // A CollectionType field arrives bimodally (see ProjectBundle\Normalizer\FormNormalizer):
      // a bare array of row objects when populated, or an object {data:[], prototype} when empty.
      // We iterate only the populated (array) form; addRow/removeRow below handle the flip.
      return Array.isArray(this.value) ? this.value : [];
    },
    columns: function columns() {
      return [{ key: 'value', label: 'Threshold (minor units)' }];
    },
    currencyChoices: function currencyChoices() {
      // The prototype carries currency choices only while the field is empty (0 rows); once rows
      // exist the prototype is gone and each row re-emits an identical choices list, so we fall
      // back to the first row's choices.
      var proto = this.value && this.value.prototype;
      var src = proto ? proto.currency : this.rows[0] && this.rows[0].currency;
      return src && src.choices || [];
    }
  },
  methods: {
    isLocked: function isLocked(row) {
      return this.type === 'dust' && row.currency && row.currency.data === 'default';
    },
    emptyRow: function emptyRow() {
      // Seed the new row's currency choices from the prototype (empty map) or the existing rows
      // (populated map): addRow flips {data:[],prototype} to a bare array and would otherwise drop
      // the prototype's choices, leaving the dropdown empty on the first row of an empty map.
      var row = { currency: { data: '', choices: this.currencyChoices } };
      this.columns.forEach(function (col) {
        row[col.key] = { data: '' };
      });
      return row;
    },
    addRow: function addRow() {
      if (!Array.isArray(this.value)) {
        this.$emit('input', [this.emptyRow()]);
      } else {
        this.value.push(this.emptyRow());
      }
    },
    removeRow: function removeRow(index) {
      this.value.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "GBsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  label: 'Common Settings',
  path: 'commonSettings',
  fields: [{
    label: 'Enable Conversion',
    type: 'c-switch',
    path: 'payment.configuration.commonSettings.enableConversion'
  }]
}, {
  label: 'Accentpay',
  path: 'accentpay',
  enabledPath: 'payment.configuration.accentpay.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.accentpay.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.accentpay.demo' }, {
    label: 'Deposit Method',
    type: 'c-multi-select',
    path: 'payment.configuration.accentpay.methods.deposit'
  }, {
    label: 'Withdraw Method',
    type: 'c-multi-select',
    path: 'payment.configuration.accentpay.methods.withdraw'
  }, { label: 'Site ID', type: 'c-input', path: 'payment.configuration.accentpay.siteId' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.accentpay.salt' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.accentpay.types' }]
}, {
  label: 'Api24',
  path: 'api24',
  enabledPath: 'payment.configuration.api24.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.api24.currencies' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.api24.apiKey' }, { label: 'Api URL', type: 'c-input', path: 'payment.configuration.api24.apiUrl' }, { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.api24.verifyUrl' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.api24.types' }]
}, {
  label: 'Apple Pay',
  path: 'apple_pay',
  enabledPath: 'payment.configuration.apple_pay.enable',
  fields: [{ label: 'Bundle Id', type: 'c-input', path: 'payment.configuration.apple_pay.bundleId' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.apple_pay.demo' }]
}, {
  label: 'Ariapay',
  path: 'ariapay',
  enabledPath: 'payment.configuration.ariapay.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.ariapay.currencies' }, { label: 'Pin', type: 'c-input', path: 'payment.configuration.ariapay.pin' }, { label: 'Api URL', type: 'c-input', path: 'payment.configuration.ariapay.apiUrl' }, { label: 'Redirect URL', type: 'c-input', path: 'payment.configuration.ariapay.redirectUrl' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ariapay.types' }]
}, {
  label: 'Bank Transfer',
  path: 'bank-transfer',
  enabledPath: 'payment.configuration.bank_transfer.enable',
  fields: [{
    label: 'Deposit Method',
    type: 'c-multi-select',
    path: 'payment.configuration.bank_transfer.methods.deposit'
  }, {
    label: 'Withdraw Method',
    type: 'c-multi-select',
    path: 'payment.configuration.bank_transfer.methods.withdraw'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.bank_transfer.types' }, {
    label: 'Custom Withdraw Commission',
    type: 'c-checkbox',
    path: 'payment.configuration.bank_transfer.custom_withdraw_commission'
  }]
}, {
  label: 'Bitcoin',
  path: 'bitcoin',
  enabledPath: 'payment.configuration.bitcoin.enable',
  fields: [{ label: 'Demo', type: 'c-switch', path: 'payment.configuration.bitcoin.demo' }, { label: 'Key', type: 'c-input', path: 'payment.configuration.bitcoin.key' }, { label: 'Timezone', type: 'c-input', path: 'payment.configuration.bitcoin.timezone' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.bitcoin.types' }]
}, {
  label: 'Blocktrail',
  path: 'blocktrail',
  enabledPath: 'payment.configuration.blocktrail.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.blocktrail.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.blocktrail.demo' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.blocktrail.secret' }, { label: 'Key', type: 'c-input', path: 'payment.configuration.blocktrail.key' }, { label: 'Passhrase', type: 'c-input', path: 'payment.configuration.blocktrail.passhrase' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.blocktrail.types' }, {
    label: 'Manual Withdraw',
    type: 'c-checkbox',
    path: 'payment.configuration.blocktrail.manual.withdraw'
  }]
}, {
  label: 'Casino',
  path: 'casino',
  enabledPath: 'payment.configuration.casino.enable',
  fields: [{ label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.casino.types' }]
}, {
  label: 'Coinbase',
  path: 'coinbase',
  enabledPath: 'payment.configuration.coinbase.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.coinbase.currencies' }, { label: 'Api key', type: 'c-input', path: 'payment.configuration.coinbase.apiKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.coinbase.types' }]
}, {
  label: 'Coingate',
  path: 'coingate',
  enabledPath: 'payment.configuration.coingate.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.coingate.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.coingate.demo' }, { label: 'Description', type: 'c-input', path: 'payment.configuration.coingate.description' }, {
    label: 'Receive Currency',
    type: 'c-select',
    path: 'payment.configuration.coingate.receiveCurrency'
  }, { label: 'Title', type: 'c-input', path: 'payment.configuration.coingate.title' }, { label: 'Token', type: 'c-input', path: 'payment.configuration.coingate.token' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.coingate.types' }]
}, {
  label: 'Cubits',
  path: 'cubits',
  enabledPath: 'payment.configuration.cubits.enable',
  fields: [{
    label: 'Channel Description',
    type: 'c-input',
    path: 'payment.configuration.cubits.channelDescription'
  }, { label: 'Channel Name', type: 'c-input', path: 'payment.configuration.cubits.channelName' }, { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.cubits.currencies' }, { label: 'Key', type: 'c-input', path: 'payment.configuration.cubits.key' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.cubits.secret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cubits.types' }]
}, {
  label: 'Easebuzz',
  path: 'easebuzz',
  enabledPath: 'payment.configuration.easebuzz.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.easebuzz.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.easebuzz.demo' }, { label: 'Domain', type: 'c-input', path: 'payment.configuration.easebuzz.domain' }, { label: 'Merchant key', type: 'c-input', path: 'payment.configuration.easebuzz.merchantKey' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.easebuzz.salt' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.easebuzz.types' }]
}, {
  label: 'Omniware',
  path: 'omniware',
  enabledPath: 'payment.configuration.omniware.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.omniware.currencies' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.omniware.salt' }, { label: 'Domain', type: 'c-input', path: 'payment.configuration.omniware.domain' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.omniware.api_key' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.omniware.types' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.omniware.demo' }]
}, {
  label: 'Paed',
  path: 'paed',
  enabledPath: 'payment.configuration.paed.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paed.currencies' }, { label: 'Mid', type: 'c-input', path: 'payment.configuration.paed.mid' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.paed.apiKey' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.paed.password' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paed.types' }]
}, {
  label: 'UpiGateway',
  path: 'upigateway',
  enabledPath: 'payment.configuration.upigateway.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.upigateway.currencies' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.upigateway.types' }]
}, {
  label: 'Floxy',
  path: 'floxy',
  enabledPath: 'payment.configuration.floxy.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.floxy.currencies' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.floxy.secret' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.floxy.api_key' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.floxy.types' }]
}, {
  label: 'Epaygate',
  path: 'epaygate',
  enabledPath: 'payment.configuration.epaygate.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.epaygate.currencies' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.epaygate.secret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.epaygate.types' }]
}, {
  label: 'Kwidpay',
  path: 'kwidpay',
  enabledPath: 'payment.configuration.kwidpay.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.kwidpay.currencies' }, { label: 'Token', type: 'c-input', path: 'payment.configuration.kwidpay.token' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.kwidpay.types' }]
}, {
  label: 'PaySix',
  path: 'paysix',
  enabledPath: 'payment.configuration.paysix.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paysix.currencies' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.paysix.salt' }, { label: 'Domain', type: 'c-input', path: 'payment.configuration.paysix.domain' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.paysix.api_key' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paysix.types' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.paysix.demo' }, { label: 'Public Key', type: 'c-textarea', path: 'payment.configuration.paysix.public_key' }]
}, {
  label: 'First Econnect',
  path: 'first-econnect',
  enabledPath: 'payment.configuration.first_econnect.enable',
  fields: [{ label: 'URL', type: 'c-input', path: 'payment.configuration.first_econnect.url' }, { label: 'Check URL', type: 'c-input', path: 'payment.configuration.first_econnect.checkUrl' }, { label: 'Merc ID', type: 'c-input', path: 'payment.configuration.first_econnect.mercId' }, { label: 'Prod', type: 'c-input', path: 'payment.configuration.first_econnect.prod' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.first_econnect.types' }]
}, {
  label: 'Floodpay',
  path: 'floodpay',
  enabledPath: 'payment.configuration.floodpay.enable',
  fields: [{ label: 'Pin', type: 'c-input', path: 'payment.configuration.floodpay.pin' }, { label: 'Api URL', type: 'c-input', path: 'payment.configuration.floodpay.apiUrl' }, { label: 'Redirect URL', type: 'c-input', path: 'payment.configuration.floodpay.redirectUrl' }, { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.floodpay.verifyUrl' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.floodpay.types' }]
}, {
  label: 'Fluttermoney',
  path: 'fluttermoney',
  enabledPath: 'payment.configuration.fluttermoney.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.fluttermoney.currencies' }, { label: 'Api URL', type: 'c-input', path: 'payment.configuration.fluttermoney.apiUrl' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.fluttermoney.secretKey' }, { label: 'Merch Id', type: 'c-input', path: 'payment.configuration.fluttermoney.merchId' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.fluttermoney.types' }]
}, {
  label: 'Google Pay',
  path: 'google_pay',
  enabledPath: 'payment.configuration.google_pay.enable',
  fields: [{ label: 'Credentials', type: 'c-textarea', path: 'payment.configuration.google_pay.credentials' }]
}, {
  label: 'Idpay',
  path: 'idpay',
  enabledPath: 'payment.configuration.idpay.enable',
  fields: [{ label: 'URL', type: 'c-input', path: 'payment.configuration.idpay.url' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.idpay.types' }]
}, {
  label: 'Interswitch',
  path: 'interswitch',
  enabledPath: 'payment.configuration.interswitch.enable',
  fields: [{ label: 'Product ID', type: 'c-input', path: 'payment.configuration.interswitch.productId' }, { label: 'Pay Item ID', type: 'c-input', path: 'payment.configuration.interswitch.payItemId' }, { label: 'Mackey', type: 'c-input', path: 'payment.configuration.interswitch.mackey' }, { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.interswitch.merchantName' }, { label: 'Post Url', type: 'c-input', path: 'payment.configuration.interswitch.postUrl' }, { label: 'Query Url', type: 'c-input', path: 'payment.configuration.interswitch.queryUrl' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.interswitch.types' }]
}, {
  label: 'Mastercard',
  path: 'mastercard',
  enabledPath: 'payment.configuration.mastercard.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.mastercard.currencies' }, { label: 'Merchant Key', type: 'c-input', path: 'payment.configuration.mastercard.merchantKey' }, { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.mastercard.merchantName' }, {
    label: 'Merchant Address',
    type: 'c-input',
    path: 'payment.configuration.mastercard.merchantAddress'
  }, {
    label: 'Order Description',
    type: 'c-input',
    path: 'payment.configuration.mastercard.orderDescription'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.mastercard.types' }]
}, {
  label: 'Monetbil',
  path: 'monetbil',
  enabledPath: 'payment.configuration.monetbil.enable',
  fields: [{ label: 'Logo', type: 'c-input', path: 'payment.configuration.monetbil.logo' }, { label: 'Service Key', type: 'c-input', path: 'payment.configuration.monetbil.serviceKey' }, { label: 'Service Secret', type: 'c-input', path: 'payment.configuration.monetbil.serviceSecret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.money_matrix.types' }]
}, {
  label: 'Money Matrix',
  path: 'money_matrix',
  enabledPath: 'payment.configuration.money_matrix.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.money_matrix.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.money_matrix.demo' }, { label: 'Merchant ID', type: 'c-input', path: 'payment.configuration.money_matrix.merchantId' }, { label: 'Merchant Key', type: 'c-input', path: 'payment.configuration.money_matrix.merchantKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.money_matrix.types' }]
}, {
  label: 'Neteller',
  path: 'neteller',
  enabledPath: 'payment.configuration.neteller.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.neteller.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.neteller.demo' }, { label: 'Client ID', type: 'c-input', path: 'payment.configuration.neteller.clientId' }, { label: 'Client Secret', type: 'c-input', path: 'payment.configuration.neteller.clientSecret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.neteller.types' }]
}, {
  label: 'Parspay',
  path: 'parspay',
  enabledPath: 'payment.configuration.parspay.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.parspay.currencies' }, { label: 'Pin', type: 'c-input', path: 'payment.configuration.parspay.pin' }, { label: 'Create URL', type: 'c-input', path: 'payment.configuration.parspay.createUrl' }, { label: 'Start Pay URL', type: 'c-input', path: 'payment.configuration.parspay.startPayUrl' }, { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.parspay.verifyUrl' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.parspay.types' }]
}, {
  label: 'Paydirect',
  path: 'paydirect',
  enabledPath: 'payment.configuration.paydirect.enable',
  fields: [{ label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paydirect.types' }]
}, {
  label: 'Paysec',
  path: 'paysec',
  enabledPath: 'payment.configuration.paysec.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paysec.currencies' }, {
    label: 'Currencies Wallets',
    type: 'payment-paysec-currencies-wallets',
    path: 'payment.configuration.paysec.currenciesWallets',
    payload: {
      currencies: 'payment.configuration.paysec.currencies'
    }
  }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.paysec.demo' }, { label: 'Product Code', type: 'c-input', path: 'payment.configuration.paysec.productCode' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paysec.types' }]
}, {
  label: 'Payvision',
  path: 'payvision',
  enabledPath: 'payment.configuration.payvision.enable',
  fields: [{ label: 'Demo', type: 'c-switch', path: 'payment.configuration.payvision.demo' }, { label: 'Member ID', type: 'c-input', path: 'payment.configuration.payvision.memberId' }, { label: 'Member Guid', type: 'c-input', path: 'payment.configuration.payvision.memberGuid' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payvision.types' }]
}, {
  label: 'Praxis',
  path: 'praxis',
  enabledPath: 'payment.configuration.praxis.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.praxis.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.praxis.demo' }, { label: 'Frontend', type: 'c-input', path: 'payment.configuration.praxis.frontend' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.praxis.merchantId' }, { label: 'Merchant Secret', type: 'c-input', path: 'payment.configuration.praxis.merchantSecret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.praxis.types' }]
}, {
  label: 'Safecharge',
  path: 'safecharge',
  enabledPath: 'payment.configuration.safecharge.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.safecharge.currencies' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.safecharge.demo' }, { label: 'Merchant Site', type: 'c-input', path: 'payment.configuration.safecharge.merchantSite' }, { label: 'Merchant Site ID', type: 'c-input', path: 'payment.configuration.safecharge.merchantSiteId' }, { label: 'Merchant ID', type: 'c-input', path: 'payment.configuration.safecharge.merchantId' }, { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.safecharge.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.safecharge.types' }]
}, {
  label: 'Skrill',
  path: 'skrill',
  enabledPath: 'payment.configuration.skrill.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.skrill.currencies' }, { label: 'Email', type: 'c-input', path: 'payment.configuration.skrill.email' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.skrill.secret' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.skrill.password' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.skrill.types' }, { label: 'Manual Withdraw', type: 'c-checkbox', path: 'payment.configuration.skrill.manual.withdraw' }]
}, {
  label: 'Spark Pay',
  path: 'sparkpay',
  enabledPath: 'payment.configuration.sparkpay.enable',
  fields: [{ label: 'Key', type: 'c-input', path: 'payment.configuration.sparkpay.key' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.sparkpay.password' }, { label: 'Partner Login Id', type: 'c-input', path: 'payment.configuration.sparkpay.partnerLoginId' }, { label: 'Checkout Url', type: 'c-input', path: 'payment.configuration.sparkpay.checkoutUrl' }, { label: 'Status Check Url', type: 'c-input', path: 'payment.configuration.sparkpay.statusCheckUrl' }, { label: 'Withdraw Url', type: 'c-input', path: 'payment.configuration.sparkpay.withdrawUrl' }, { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.sparkpay.merchantName' }, { label: 'Logo', type: 'c-input', path: 'payment.configuration.sparkpay.logo' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sparkpay.types' }]
}, {
  label: 'Sybapal',
  path: 'sybapal',
  enabledPath: 'payment.configuration.sybapal.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.sybapal.currencies' }, { label: 'Pin', type: 'c-input', path: 'payment.configuration.sybapal.pin' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sybapal.types' }]
}, {
  label: 'Tarjeta',
  path: 'tarjeta',
  enabledPath: 'payment.configuration.tarjeta.enable',
  fields: [{ label: 'URL', type: 'c-input', path: 'payment.configuration.tarjeta.url' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tarjeta.types' }]
}, {
  label: 'Ultimpay',
  path: 'ultimpay',
  enabledPath: 'payment.configuration.ultimpay.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.ultimpay.currencies' }]
}, {
  label: 'Wirecard',
  path: 'wirecard',
  enabledPath: 'payment.configuration.wirecard.enable',
  fields: [{ label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.wirecard.currencies' }, { label: 'Login', type: 'c-input', path: 'payment.configuration.wirecard.login' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.wirecard.password' }, { label: 'Business Key', type: 'c-input', path: 'payment.configuration.wirecard.businessKey' }, { label: 'Business Key 3D', type: 'c-input', path: 'payment.configuration.wirecard.businessKey3d' }, { label: '3D', type: 'c-switch', path: 'payment.configuration.wirecard.3d' }, { label: 'Demo', type: 'c-switch', path: 'payment.configuration.wirecard.demo' }, { label: 'Checkout', type: 'c-switch', path: 'payment.configuration.wirecard.checkout' }, { label: 'Commission', type: 'c-switch', path: 'payment.configuration.wirecard.commission' }, { label: 'Toolkit Password', type: 'c-input', path: 'payment.configuration.wirecard.toolkitPassword' }, { label: 'Customer ID', type: 'c-input', path: 'payment.configuration.wirecard.customerId' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.wirecard.secret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.wirecard.types' }, {
    label: 'Manual Withdraw',
    type: 'c-checkbox',
    path: 'payment.configuration.wirecard.manual.withdraw'
  }]
}, {
  label: 'Rapidteenpatti',
  path: 'rapidteenpatti',
  enabledPath: 'payment.configuration.rapidteenpatti.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.rapidteenpatti.currencies'
  }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.rapidteenpatti.types'
  }]
}, {
  label: 'Instant',
  path: 'instant',
  enabledPath: 'payment.configuration.instant.enable',
  fields: [{ label: 'Url', type: 'c-input', path: 'payment.configuration.instant.url' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.instant.currencies'
  }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.instant.types'
  }]
}, {
  label: 'Manual Deposit',
  path: 'manualdeposit',
  enabledPath: 'payment.configuration.manualdeposit.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.manualdeposit.currencies'
  }, { label: 'Trello Api Key', type: 'c-input', path: 'payment.configuration.manualdeposit.trelloApiKey' }, {
    label: 'Trello Api Secret',
    type: 'c-input',
    path: 'payment.configuration.manualdeposit.trelloSecret'
  }, { label: 'Trello List Id', type: 'c-input', path: 'payment.configuration.manualdeposit.listId' }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.manualdeposit.types'
  }]
}, {
  label: 'Paygate',
  path: 'paygate',
  enabledPath: 'payment.configuration.paygate.enable',
  fields: [{ label: 'Mid code', type: 'c-input', path: 'payment.configuration.paygate.mid_code' }, { label: 'Mid secret', type: 'c-input', path: 'payment.configuration.paygate.mid_secret' }, { label: 'Domain', type: 'c-input', path: 'payment.configuration.paygate.domain' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paygate.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paygate.types' }]
}, {
  label: 'S2pay',
  path: 's2pay',
  enabledPath: 'payment.configuration.s2pay.enable',
  fields: [{ label: 'URL', type: 'c-input', path: 'payment.configuration.s2pay.url' }, { label: 'Mid secret', type: 'c-input', path: 'payment.configuration.s2pay.salt' }, { label: 'Encription Key', type: 'c-input', path: 'payment.configuration.s2pay.encryptionKey' }, { label: 'Decryption Key', type: 'c-input', path: 'payment.configuration.s2pay.decryptionKey' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.s2pay.apiKey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.s2pay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.s2pay.types' }]
}, {
  label: 'Airpay',
  path: 'airpay',
  enabledPath: 'payment.configuration.airpay.enable',
  fields: [{ label: 'Username', type: 'c-input', path: 'payment.configuration.airpay.username' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.airpay.password' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.airpay.apiKey' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.airpay.merchantId' }, { label: 'Domain', type: 'c-input', path: 'payment.configuration.airpay.domain' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.airpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.airpay.types' }]
}, {
  label: 'Nexapay',
  path: 'nexapay',
  enabledPath: 'payment.configuration.nexapay.enable',
  fields: [{ label: 'Pay Id', type: 'c-input', path: 'payment.configuration.nexapay.payId' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.nexapay.secretKey' }, { label: 'Hosted Key', type: 'c-input', path: 'payment.configuration.nexapay.hostedKey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.nexapay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.nexapay.types' }]
}, {
  label: 'Vaderpay',
  path: 'vaderpay',
  enabledPath: 'payment.configuration.vaderpay.enable',
  fields: [{ label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.vaderpay.merchantId' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vaderpay.apiKey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.vaderpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vaderpay.types' }]
}, {
  label: 'Codunit',
  path: 'codunit',
  enabledPath: 'payment.configuration.codunit.enable',
  fields: [{ label: 'Token', type: 'c-input', path: 'payment.configuration.codunit.token' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.codunit.password' }, { label: 'Member ID', type: 'c-input', path: 'payment.configuration.codunit.memberId' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.codunit.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.codunit.types' }]
}, {
  label: 'Vaderpay Net Banking',
  path: 'vaderpaybank',
  enabledPath: 'payment.configuration.vaderpaybank.enable',
  fields: [{ label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.vaderpaybank.merchantId' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vaderpaybank.apiKey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.vaderpaybank.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vaderpaybank.types' }]
}, {
  label: 'SmartPay',
  path: 'smartpay',
  enabledPath: 'payment.configuration.smartpay.enable',
  fields: [{ label: 'Mid Code', type: 'c-input', path: 'payment.configuration.smartpay.midCode' }, { label: 'Mid Secret', type: 'c-input', path: 'payment.configuration.smartpay.midSecret' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.smartpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.smartpay.types' }]
}, {
  label: 'Step2Pay',
  path: 'steppay',
  enabledPath: 'payment.configuration.steppay.enable',
  fields: [{ label: 'User', type: 'c-input', path: 'payment.configuration.steppay.user' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.steppay.password' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.steppay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.steppay.types' }]
}, {
  label: 'Recopay',
  path: 'reco',
  enabledPath: 'payment.configuration.reco.enable',
  fields: [{ label: 'Mid', type: 'c-input', path: 'payment.configuration.reco.mid' }, { label: 'Token', type: 'c-input', path: 'payment.configuration.reco.token' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.reco.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.reco.types' }]
}, {
  label: 'Psk',
  path: 'psk',
  enabledPath: 'payment.configuration.psk.enable',
  fields: [{ label: 'Pid', type: 'c-input', path: 'payment.configuration.psk.pid' }, { label: 'Key', type: 'c-input', path: 'payment.configuration.psk.key' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.psk.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.psk.types' }]
}, {
  label: 'Payu',
  path: 'payu',
  enabledPath: 'payment.configuration.payu.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.payu.currencies'
  }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.payu.salt' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.payu.api_key' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payu.types' }]
}, {
  label: 'F2pay',
  path: 'f2pay',
  enabledPath: 'payment.configuration.f2pay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.f2pay.currencies'
  }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.f2pay.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.f2pay.privateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.f2pay.types' }]
}, {
  label: 'Freepay',
  path: 'freepay',
  enabledPath: 'payment.configuration.freepay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.freepay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.freepay.types' }]
}, {
  label: 'Einpays',
  path: 'einpays',
  enabledPath: 'payment.configuration.einpays.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.einpays.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.einpays.apiUrl' }, { label: 'Client ID', type: 'c-input', path: 'payment.configuration.einpays.clientId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.einpays.privateKey' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.einpays.einpaysPublicKey' }, { label: 'Payin method', type: 'c-input', path: 'payment.configuration.einpays.payinMethod' }, { label: 'Payout method', type: 'c-input', path: 'payment.configuration.einpays.payoutMethod' }, { label: 'Country', type: 'c-input', path: 'payment.configuration.einpays.countryId' }, { label: 'Currency', type: 'c-input', path: 'payment.configuration.einpays.currencyId' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.einpays.types' }]
}, {
  label: 'Vexora',
  path: 'vexora',
  enabledPath: 'payment.configuration.vexora.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.vexora.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.vexora.apiUrl' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.vexora.merchantId' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vexora.apiKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vexora.types' }]
}, {
  label: 'Payok',
  path: 'payok',
  enabledPath: 'payment.configuration.payok.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.payok.currencies'
  }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.payok.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.payok.merchantPrivateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payok.types' }]
}, {
  label: 'Multipay',
  path: 'multipay',
  enabledPath: 'payment.configuration.multipay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.multipay.currencies'
  }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.multipay.merchantId' }, { label: 'Api key', type: 'c-input', path: 'payment.configuration.multipay.apiKey' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.multipay.publicKey' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.multipay.privateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.multipay.types' }]
}, {
  label: 'Ipay',
  path: 'ipay',
  enabledPath: 'payment.configuration.ipay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.ipay.currencies'
  }, { label: 'Key', type: 'c-input', path: 'payment.configuration.ipay.key' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.ipay.secret' }, { label: 'Merchant', type: 'c-input', path: 'payment.configuration.ipay.merchantId' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ipay.types' }]
}, {
  label: 'tpay',
  path: 'tpay',
  enabledPath: 'payment.configuration.tpay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.tpay.currencies'
  }, { label: 'Key', type: 'c-input', path: 'payment.configuration.tpay.appKey' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.tpay.appSecret' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tpay.types' }]
}, {
  label: 'Lionpay',
  path: 'lionpay',
  enabledPath: 'payment.configuration.lionpay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.lionpay.currencies'
  }, { label: 'url', type: 'c-input', path: 'payment.configuration.lionpay.apiUrl' }, { label: 'app id', type: 'c-input', path: 'payment.configuration.lionpay.appId' }, { label: 'cust', type: 'c-input', path: 'payment.configuration.lionpay.custId' }, { label: 'secret', type: 'c-input', path: 'payment.configuration.lionpay.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.lionpay.types' }]
}, {
  label: 'Betixpay',
  path: 'betixpay',
  enabledPath: 'payment.configuration.betixpay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.betixpay.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betixpay.apiUrl' }, { label: 'Auth no', type: 'c-input', path: 'payment.configuration.betixpay.authNo' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betixpay.publicKey' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.betixpay.secretKey' }, { label: 'Payin method', type: 'c-input', path: 'payment.configuration.betixpay.payinMethod' }, { label: 'Payout method', type: 'c-input', path: 'payment.configuration.betixpay.payoutMethod' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betixpay.types' }]
}, {
  label: 'Betixpay2',
  path: 'betixpay2',
  enabledPath: 'payment.configuration.betixpay2.enable',
  fields: [{ label: 'Auth No', type: 'c-input', path: 'payment.configuration.betixpay2.authNo' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betixpay2.publicKey' }, { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.betixpay2.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betixpay2.types' }]
}, {
  label: 'BetixpayPK',
  path: 'betixpaypkr',
  enabledPath: 'payment.configuration.betixpaypkr.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.betixpaypkr.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betixpaypkr.apiUrl' }, { label: 'Auth no', type: 'c-input', path: 'payment.configuration.betixpaypkr.authNo' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betixpaypkr.publicKey' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.betixpaypkr.secretKey' }, { label: 'Payin method', type: 'c-input', path: 'payment.configuration.betixpaypkr.payinMethod' }, { label: 'Payout method', type: 'c-input', path: 'payment.configuration.betixpaypkr.payoutMethod' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betixpaypkr.types' }]
}, {
  label: 'Pay2play',
  path: 'pay2play',
  enabledPath: 'payment.configuration.pay2play.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.pay2play.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.pay2play.apiUrl' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.pay2play.merchantId' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.pay2play.apiKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pay2play.types' }]
}, {
  label: 'Ninepay',
  path: 'ninepay',
  enabledPath: 'payment.configuration.ninepay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.ninepay.currencies'
  }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.ninepay.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ninepay.types' }]
}, {
  label: 'Tecpay',
  path: 'tecpay',
  enabledPath: 'payment.configuration.tecpay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.tecpay.currencies'
  }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.tecpay.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.tecpay.privateKey' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.tecpay.publicKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tecpay.types' }]
}, {
  label: 'Starpagopkreasypaisa',
  path: 'starpagopkreasypaisa',
  enabledPath: 'payment.configuration.starpagopkreasypaisa.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.starpagopkreasypaisa.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.starpagopkreasypaisa.apiUrl' }, { label: 'App ID', type: 'c-input', path: 'payment.configuration.starpagopkreasypaisa.appId' }, { label: 'App Key', type: 'c-input', path: 'payment.configuration.starpagopkreasypaisa.appKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.starpagopkreasypaisa.types' }]
}, {
  label: 'Starpagopkrjazzcash',
  path: 'starpagopkrjazzcash',
  enabledPath: 'payment.configuration.starpagopkrjazzcash.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.starpagopkrjazzcash.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.starpagopkrjazzcash.apiUrl' }, { label: 'App ID', type: 'c-input', path: 'payment.configuration.starpagopkrjazzcash.appId' }, { label: 'App Key', type: 'c-input', path: 'payment.configuration.starpagopkrjazzcash.appKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.starpagopkrjazzcash.types' }]
}, {
  label: 'mgpkrjazzcash',
  path: 'mgpkrjazzcash',
  enabledPath: 'payment.configuration.mgpkrjazzcash.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.mgpkrjazzcash.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.mgpkrjazzcash.apiUrl' }, { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.mgpkrjazzcash.mchId' }, { label: 'Pay Key', type: 'c-input', path: 'payment.configuration.mgpkrjazzcash.payKey' }, { label: 'Payout Key', type: 'c-input', path: 'payment.configuration.mgpkrjazzcash.payoutKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.mgpkrjazzcash.types' }]
}, {
  label: 'mgpkreasypaisa',
  path: 'mgpkreasypaisa',
  enabledPath: 'payment.configuration.mgpkreasypaisa.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.mgpkreasypaisa.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.mgpkreasypaisa.apiUrl' }, { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.mgpkreasypaisa.mchId' }, { label: 'Pay Key', type: 'c-input', path: 'payment.configuration.mgpkreasypaisa.payKey' }, { label: 'Payout Key', type: 'c-input', path: 'payment.configuration.mgpkreasypaisa.payoutKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.mgpkreasypaisa.types' }]
}, {
  label: 'TecpayEasy',
  path: 'tecpayeasy',
  enabledPath: 'payment.configuration.tecpayeasy.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.tecpayeasy.currencies'
  }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.tecpayeasy.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.tecpayeasy.privateKey' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.tecpayeasy.publicKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tecpayeasy.types' }]
}, {
  label: 'Asanpaypkr',
  path: 'asanpaypkr',
  enabledPath: 'payment.configuration.asanpaypkr.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.asanpaypkr.currencies'
  }, { label: 'URL', type: 'c-input', path: 'payment.configuration.asanpaypkr.apiUrl' }, { label: 'Merc ID', type: 'c-input', path: 'payment.configuration.asanpaypkr.merchantId' }, { label: 'API Key', type: 'c-input', path: 'payment.configuration.asanpaypkr.apiKey' }, { label: 'Store name', type: 'c-input', path: 'payment.configuration.asanpaypkr.storeName' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.asanpaypkr.types' }]
}, {
  label: 'Paykassma',
  path: 'paykassma',
  enabledPath: 'payment.configuration.paykassma.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paykassma.currencies'
  }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassma.privateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassma.types' }]
}, {
  label: 'PaykassmaJazz',
  path: 'paykassma_pkr_jazzcash',
  enabledPath: 'payment.configuration.paykassma_pkr_jazzcash.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paykassma_pkr_jazzcash.currencies'
  }, {
    label: 'Private Key',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_jazzcash.privateKey'
  }, {
    label: 'webhook Id',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_jazzcash.webhookId'
  }, {
    label: 'project Id',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_jazzcash.projectId'
  }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.paykassma_pkr_jazzcash.types'
  }]
}, {
  label: 'PaykassmaEasy',
  path: 'paykassma_pkr_easypaisa',
  enabledPath: 'payment.configuration.paykassma_pkr_easypaisa.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paykassma_pkr_easypaisa.currencies'
  }, {
    label: 'Private Key',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_easypaisa.privateKey'
  }, {
    label: 'webhook Id',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_easypaisa.webhookId'
  }, {
    label: 'project Id',
    type: 'c-input',
    path: 'payment.configuration.paykassma_pkr_easypaisa.projectId'
  }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.paykassma_pkr_easypaisa.types'
  }]
}, {
  label: 'PaykassmaLink',
  path: 'paykassmalink',
  enabledPath: 'payment.configuration.paykassmalink.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paykassmalink.currencies'
  }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassmalink.privateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassmalink.types' }]
}, {
  label: 'PaykassmaUpiFast',
  path: 'paykassmaupifast',
  enabledPath: 'payment.configuration.paykassmaupifast.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paykassmaupifast.currencies'
  }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassmaupifast.privateKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassmaupifast.types' }]
}, {
  label: 'Silkpay',
  path: 'silkpay',
  enabledPath: 'payment.configuration.silkpay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.silkpay.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.silkpay.apiUrl' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.silkpay.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.silkpay.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.silkpay.types' }]
}, {
  label: 'Paypulsepoint',
  path: 'paypulsepoint',
  enabledPath: 'payment.configuration.paypulsepoint.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paypulsepoint.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.paypulsepoint.apiUrl' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.paypulsepoint.merchantId' }, { label: 'payin Api Key', type: 'c-input', path: 'payment.configuration.paypulsepoint.payinApiKey' }, {
    label: 'payin Encryption Key',
    type: 'c-input',
    path: 'payment.configuration.paypulsepoint.payinEncryptionKey'
  }, { label: 'payout Api Key', type: 'c-input', path: 'payment.configuration.paypulsepoint.payoutApiKey' }, {
    label: 'payout Encryption Key',
    type: 'c-input',
    path: 'payment.configuration.paypulsepoint.payoutEncryptionKey'
  }, {
    label: 'Types',
    type: 'c-multi-checkbox',
    path: 'payment.configuration.paypulsepoint.types'
  }]
}, {
  label: 'Tatapay',
  path: 'tatapay',
  enabledPath: 'payment.configuration.tatapay.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.tatapay.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.tatapay.apiUrl' }, { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.tatapay.merchantId' }, { label: 'Private Key', type: 'c-input', path: 'payment.configuration.tatapay.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tatapay.types' }]
}, {
  label: 'Betatransfer',
  path: 'betatransfer',
  enabledPath: 'payment.configuration.betatransfer.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.betatransfer.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betatransfer.apiUrl' }, { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betatransfer.publicKey' }, { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.betatransfer.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betatransfer.types' }]
}, {
  label: 'Finaxis',
  path: 'finaxis',
  enabledPath: 'payment.configuration.finaxis.enable',
  fields: [{
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.finaxis.currencies'
  }, { label: 'Api Url', type: 'c-input', path: 'payment.configuration.finaxis.apiUrl' }, { label: 'Api Key', type: 'c-input', path: 'payment.configuration.finaxis.apiKey' }, { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.finaxis.secretKey' }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.finaxis.types' }]
}, {
  label: 'Pinwallet',
  path: 'pinwallet',
  enabledPath: 'payment.configuration.pinwallet.enable',
  fields: [{ label: 'Key', type: 'c-input', path: 'payment.configuration.pinwallet.key' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.pinwallet.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pinwallet.types' }]
}, {
  label: 'OfcPay',
  path: 'ofcpay',
  enabledPath: 'payment.configuration.ofcpay.enable',
  fields: [{ label: 'Aid', type: 'c-input', path: 'payment.configuration.ofcpay.aid' }, { label: 'AKey', type: 'c-input', path: 'payment.configuration.ofcpay.akey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.ofcpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ofcpay.types' }]
}, {
  label: 'Paydunia',
  path: 'paydunia',
  enabledPath: 'payment.configuration.paydunia.enable',
  fields: [{ label: 'Key', type: 'c-input', path: 'payment.configuration.paydunia.key' }, { label: 'Mid', type: 'c-input', path: 'payment.configuration.paydunia.mid' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paydunia.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paydunia.types' }]
}, {
  label: 'PBrokers',
  path: 'pbrokers',
  enabledPath: 'payment.configuration.pbrokers.enable',
  fields: [{ label: 'Username', type: 'c-input', path: 'payment.configuration.pbrokers.username' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.pbrokers.password' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.pbrokers.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pbrokers.types' }]
}, {
  label: 'Tappay',
  path: 'tappay',
  enabledPath: 'payment.configuration.tappay.enable',
  fields: [{ label: 'Mid', type: 'c-input', path: 'payment.configuration.tappay.mid' }, { label: 'Request Salt', type: 'c-input', path: 'payment.configuration.tappay.requestSalt' }, { label: 'Request Enc Key', type: 'c-input', path: 'payment.configuration.tappay.reqEncryptionKey' }, { label: 'Response Salt', type: 'c-input', path: 'payment.configuration.tappay.responseSalt' }, { label: 'Response Enc Key', type: 'c-input', path: 'payment.configuration.tappay.resEncryptionKey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.tappay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tappay.types' }]
}, {
  label: 'Paywings',
  path: 'paywings',
  enabledPath: 'payment.configuration.paywings.enable',
  fields: [{ label: 'Api Key', type: 'c-input', path: 'payment.configuration.paywings.api_key' }, { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.paywings.merchant_id' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paywings.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paywings.types' }]
}, {
  label: 'drigpay',
  path: 'drigpay',
  enabledPath: 'payment.configuration.drigpay.enable',
  fields: [{ label: 'Api Key', type: 'c-input', path: 'payment.configuration.drigpay.key' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.drigpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.drigpay.types' }]
}, {
  label: 'fintech',
  path: 'fintech',
  enabledPath: 'payment.configuration.fintech.enable',
  fields: [{ label: 'password', type: 'c-input', path: 'payment.configuration.fintech.password' }, { label: 'email', type: 'c-input', path: 'payment.configuration.fintech.email' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.fintech.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.fintech.types' }]
}, {
  label: 'saspay',
  path: 'saspay',
  enabledPath: 'payment.configuration.saspay.enable',
  fields: [{ label: 'memberid', type: 'c-input', path: 'payment.configuration.saspay.memberid' }, { label: 'salt', type: 'c-input', path: 'payment.configuration.saspay.salt' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.saspay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.saspay.types' }]
}, {
  label: 'paymore',
  path: 'paymore',
  enabledPath: 'payment.configuration.paymore.enable',
  fields: [{ label: 'Mid', type: 'c-input', path: 'payment.configuration.paymore.mid' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.paymore.salt' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.paymore.secret' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.paymore.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paymore.types' }]
}, {
  label: 'sambhav',
  path: 'sambhav',
  enabledPath: 'payment.configuration.sambhav.enable',
  fields: [{ label: 'Mid', type: 'c-input', path: 'payment.configuration.sambhav.mid' }, { label: 'Salt', type: 'c-input', path: 'payment.configuration.sambhav.salt' }, { label: 'Secret', type: 'c-input', path: 'payment.configuration.sambhav.secret' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.sambhav.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sambhav.types' }]
}, {
  label: 'Pay247',
  path: 'pay247',
  enabledPath: 'payment.configuration.pay247.enable',
  fields: [{ label: 'Pay Id', type: 'c-input', path: 'payment.configuration.pay247.payId' }, { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.pay247.secretKey' }, { label: 'Rmn', type: 'c-input', path: 'payment.configuration.pay247.rmn' }, { label: 'Password', type: 'c-input', path: 'payment.configuration.pay247.password' }, { label: 'App Secret', type: 'c-input', path: 'payment.configuration.pay247.appSecret' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.pay247.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pay247.types' }]
}, {
  label: 'Payzin',
  path: 'payzin',
  enabledPath: 'payment.configuration.payzin.enable',
  fields: [{ label: 'appId', type: 'c-input', path: 'payment.configuration.payzin.appId' }, { label: 'secret', type: 'c-input', path: 'payment.configuration.payzin.secret' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.payzin.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payzin.types' }]
}, {
  label: 'didapay',
  path: 'didapay',
  enabledPath: 'payment.configuration.didapay.enable',
  fields: [{ label: 'appId', type: 'c-input', path: 'payment.configuration.didapay.merchantNo' }, { label: 'privatekey', type: 'c-input', path: 'payment.configuration.didapay.privatekey' }, { label: 'publickey', type: 'c-input', path: 'payment.configuration.didapay.publickey' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.didapay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.didapay.types' }]
}, {
  label: 'cosmos',
  path: 'cosmos',
  enabledPath: 'payment.configuration.cosmos.enable',
  fields: [{ label: 'secretKeyDep', type: 'c-input', path: 'payment.configuration.cosmos.secretKeyDep' }, { label: 'clientIdDep', type: 'c-input', path: 'payment.configuration.cosmos.clientIdDep' }, { label: 'secretKeyWi', type: 'c-input', path: 'payment.configuration.cosmos.secretKeyW' }, { label: 'clientIdWi', type: 'c-input', path: 'payment.configuration.cosmos.clientIdW' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.cosmos.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cosmos.types' }]
}, {
  label: 'ismartpay',
  path: 'ismartpay',
  enabledPath: 'payment.configuration.ismartpay.enable',
  fields: [{ label: 'secretKeyDep', type: 'c-input', path: 'payment.configuration.ismartpay.key' }, { label: 'clientIdDep', type: 'c-input', path: 'payment.configuration.ismartpay.mid' }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.ismartpay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ismartpay.types' }]
}, {
  label: 'Depopay',
  path: 'depopay',
  enabledPath: 'payment.configuration.depopay.enable',
  fields: [{ label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.depopay.depositUrl' }, {
    label: 'Failed Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.depopay.failedUrl'
  }, {
    label: 'Success Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.depopay.successUrl'
  }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.depopay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.depopay.types' }]
}, {
  label: 'Depopay2',
  path: 'depopay2',
  enabledPath: 'payment.configuration.depopay2.enable',
  fields: [{ label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.depopay2.depositUrl' }, {
    label: 'Failed Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.depopay2.failedUrl'
  }, {
    label: 'Success Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.depopay2.successUrl'
  }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.depopay2.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.depopay2.types' }]
}, {
  label: 'Cryptopay',
  path: 'cryptopay',
  enabledPath: 'payment.configuration.cryptopay.enable',
  fields: [{ label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.cryptopay.depositUrl' }, {
    label: 'Failed Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.cryptopay.failedUrl'
  }, {
    label: 'Success Deposit Redirect Url',
    type: 'c-input',
    path: 'payment.configuration.cryptopay.successUrl'
  }, {
    label: 'Currencies',
    type: 'c-multi-select',
    path: 'payment.configuration.cryptopay.currencies'
  }, { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cryptopay.types' }]
}]);

/***/ }),

/***/ "GOdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('table',{staticClass:"table is-bordered is-striped is-narrow is-hoverable is-fullwidth"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.fieldOrder),function(field){return _c('tr',{key:field},[_c('th',[_vm._v("\n          "+_vm._s(_vm._f("humanize")(field))+"\n        ")]),_vm._v(" "),_c('td',[_c('b-checkbox',{model:{value:(_vm.value[field].registration),callback:function ($$v) {_vm.$set(_vm.value[field], "registration", $$v)},expression:"value[field].registration"}})],1),_vm._v(" "),_c('td',[_c('b-checkbox',{model:{value:(_vm.value[field].account),callback:function ($$v) {_vm.$set(_vm.value[field], "account", $$v)},expression:"value[field].account"}})],1),_vm._v(" "),_c('td',[_c('b-checkbox',{model:{value:(_vm.value[field].required),callback:function ($$v) {_vm.$set(_vm.value[field], "required", $$v)},expression:"value[field].required"}})],1),_vm._v(" "),_c('td',[_c('b-checkbox',{model:{value:(_vm.value[field].editable),callback:function ($$v) {_vm.$set(_vm.value[field], "editable", $$v)},expression:"value[field].editable"}})],1)])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("Registration")]),_vm._v(" "),_c('td',[_vm._v("Account")]),_vm._v(" "),_c('td',[_vm._v("Required")]),_vm._v(" "),_c('td',[_vm._v("Editable")])])])}]


/***/ }),

/***/ "Gu1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentPaysecCurrenciesWallets_vue__ = __webpack_require__("7v74");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72288a86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentPaysecCurrenciesWallets_vue__ = __webpack_require__("VDn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentPaysecCurrenciesWallets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72288a86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentPaysecCurrenciesWallets_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72288a86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentPaysecCurrenciesWallets_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JEtg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KKHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-user-fields',
  props: ['value'],
  data: function data() {
    return {
      fieldOrder: ['username', 'password', 'gender', 'firstName', 'lastName', 'birthday', 'currency', 'code', 'country', 'city', 'zip', 'street', 'email', 'phone', 'acceptTerms']
    };
  }
});

/***/ }),

/***/ "LE1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.node.enabledPath)?_c('c-checkbox',{model:{value:(_vm.enabledData),callback:function ($$v) {_vm.enabledData=$$v},expression:"enabledData"}}):_vm._e(),_vm._v(" "),_c('a',{class:{ 'item-link': true, 'bordered': _vm.isSelected },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleOrClick($event)}}},[_c('span',{staticClass:"label-block"},[_vm._v("\n      "+_vm._s(_vm.node.label)+"\n      "),(_vm.hasError)?_c('b-icon',{attrs:{"type":"is-danger","icon":"exclamation-circle","size":"is-small"}}):_vm._e()],1),_vm._v(" "),(_vm.hasChildren)?_c('span',{staticClass:"icon-block"},[(_vm.expanded)?_c('b-icon',{attrs:{"icon":"angle-down"}}):_vm._e(),_vm._v(" "),(!_vm.expanded)?_c('b-icon',{attrs:{"icon":"angle-left"}}):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.hasChildren && _vm.expanded)?_c('ul',_vm._l((_vm.node.children),function(node){return _c('li',{key:node.label},[_c('nav-item',{attrs:{"node":node,"errors":_vm.errors,"errorsPaths":_vm.errorsPaths,"path":_vm.path.concat( [node.path])},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)})):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "LKdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LLfw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LgiA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("Wul2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8875ad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("ev/8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("F5yq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c8875ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8875ad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8875ad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f945df96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kOaS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("l9Xd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f945df96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f945df96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mddy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("5hOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795a20be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("igua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("JEtg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795a20be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795a20be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mq2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-multi-input',
  props: ['value'],
  methods: {
    add: function add() {
      this.value.push({ data: '' });
    },
    remove: function remove(index) {
      this.value.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy__ = __webpack_require__("O3Oo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_string__ = __webpack_require__("7302");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Projects_Form_Fields__ = __webpack_require__("wlpy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__ = __webpack_require__("/KV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_buefy___default.a, { defaultIconPack: 'fa' });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('fields', __WEBPACK_IMPORTED_MODULE_5__components_Projects_Form_Fields__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('humanize', __WEBPACK_IMPORTED_MODULE_4__lib_utils_string__["a" /* humanize */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */] }
});

/***/ }),

/***/ "O4pc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"columns"}),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"block"},_vm._l((_vm.presetTypes),function(presetType){return _c('b-radio',{key:presetType,attrs:{"native-value":presetType},on:{"input":_vm.changePresetType},model:{value:(_vm.activePresetType),callback:function ($$v) {_vm.activePresetType=$$v},expression:"activePresetType"}},[_vm._v("\n            "+_vm._s(_vm._f("humanize")(presetType))+"\n          ")])}))])]),_vm._v(" "),_vm._l((_vm.userTypes),function(userType){return _c('div',{key:userType,staticClass:"box"},[_c('b-field',{attrs:{"label":_vm._f("humanize")(userType)}}),_vm._v(" "),_c('div',{staticClass:"block"},[_vm._v("\n        Default Route\n        "),_c('b-field',[_c('b-input',{model:{value:(_vm.derivedValue[userType].defaultRoute),callback:function ($$v) {_vm.$set(_vm.derivedValue[userType], "defaultRoute", $$v)},expression:"derivedValue[userType].defaultRoute"}})],1),_vm._v(" "),_vm._l((_vm.actions),function(action){return _c('b-checkbox',{key:action,attrs:{"native-value":action},model:{value:(_vm.derivedValue[userType].actions),callback:function ($$v) {_vm.$set(_vm.derivedValue[userType], "actions", $$v)},expression:"derivedValue[userType].actions"}},[_vm._v("\n        "+_vm._s(_vm._f("humanize")(action))+"\n        ")])})],2)],1)})],2)}
var staticRenderFns = []


/***/ }),

/***/ "OMPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-form"}},[(_vm.loaded)?_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('section',{staticClass:"main-content columns is-fullheight"},[_c('aside',{staticClass:"column is-narrow sidebar"},[_c('ul',{staticClass:"menu-list"},_vm._l((_vm.tree),function(node){return _c('li',{key:node.label},[_c('nav-item',{attrs:{"errors":_vm.errors,"node":node,"path":[node.path],"errorsPaths":_vm.errorsPaths},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)}))]),_vm._v(" "),_c('div',{staticClass:"column form-container"},[(_vm.currentNode)?_c('section',[_c('b-field',{attrs:{"horizontal":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.currentNode.label))])]),_vm._v(" "),_c('fields',{attrs:{"errors":_vm.errors,"node":_vm.currentNode},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_vm._v(" "),_c('input',{staticClass:"button is-success",attrs:{"type":"submit","value":"Save"}}),_vm._v(" "),_c('a',{staticClass:"button is-info",attrs:{"href":("http://" + _vm.domain + "/initialize"),"target":"_blank"}},[_vm._v("Initialize")]),_vm._v(" "),_c('a',{staticClass:"button is-info",on:{"click":function($event){$event.preventDefault();_vm.flushCache($event)}}},[_vm._v("Flush Cache")]),_vm._v(" "),_c('a',{staticClass:"button is-info",on:{"click":function($event){$event.preventDefault();_vm.flushGameCache($event)}}},[_vm._v("Flush Game Cache")]),_vm._v(" "),_c('router-link',{staticClass:"button submit is-danger is-pulled-right",attrs:{"to":"/projects"}},[_vm._v("Back")])],1):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "Ogkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = serializeForm;
/* unused harmony export serializeMultiCheckbox */
/* unused harmony export serializeArray */
/* unused harmony export serializeSlavesField */
/* unused harmony export serializeResultField */
/* unused harmony export isArray */
/* unused harmony export isMultiCheckbox */
/* unused harmony export isSwitch */
/* unused harmony export isInput */
/* unused harmony export isSelect */
/* unused harmony export isMultiSelect */
/* unused harmony export isMultiInput */
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["b"] = flattenObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = findNodeByPath;
/* unused harmony export isBonusCurrencyMap */
/* unused harmony export serializeBonusCurrencyMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);



function serializeForm(form) {
  var result = {};
  for (var key in form) {
    var field = form[key];
    if (key === 'slaves') {
      result[key] = serializeSlavesField(field);
    } else if (key === 'result') {
      result[key] = serializeResultField(field);
      // send empty array if configuration object is empty
    } else if (key === 'configuration' && field.data === '') {
      result[key] = field.data || [];
    } else if (key === 'dust_threshold' && isBonusCurrencyMap(field)) {
      result[key] = serializeBonusCurrencyMap(field);
    } else if (field.hasOwnProperty('data')) {
      result[key] = field.data;
    } else if (isArray(field)) {
      result[key] = serializeArray(field);
    } else if (isMultiCheckbox(field)) {
      result[key] = serializeMultiCheckbox(field);
    } else {
      result[key] = serializeForm(field);
    }
  }
  return result;
}

function serializeMultiCheckbox(field) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(field).reduce(function (arr, index) {
    return field[index].data ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr), [index]) : arr;
  }, []);
}

function serializeArray(field) {
  return field.reduce(function (arr, item) {
    if (item.data) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(arr), [item.label]);
    } else {
      return arr;
    }
  }, []);
}

function serializeSlavesField(field) {
  var recordSlaves = function recordSlaves(item) {
    var newItem = {};
    for (var propName in item) {
      if (hasOwnProperty.call(item, propName)) {
        newItem[propName] = item[propName].data;
      }
    }
    return newItem;
  };
  if (field.data) {
    return field.data.map(function (item) {
      return recordSlaves(item);
    });
  } else {
    return field.map(function (item) {
      return recordSlaves(item);
    });
  }
}

function serializeResultField(field) {
  var data = void 0;
  if (field.hasOwnProperty('prototype')) {
    data = field.data || [];
  } else {
    data = field.data || field;
  }
  return data.map(function (item) {
    return {
      condition: item.condition.data,
      status: item.status.data
    };
  });
}

function isArray(field) {
  return Array.isArray(field) && field.length && field[0].label;
}

function isMultiCheckbox(field) {
  return !Array.isArray(field) && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(field).every(function (key) {
    return !isNaN(parseInt(key, 10));
  });
}

function isSwitch(field) {
  return field.hasOwnProperty('data') && !field.hasOwnProperty('label') && typeof field.data === 'boolean';
}

function isInput(field) {
  return field.hasOwnProperty('data') && !field.hasOwnProperty('choices') && typeof field.data === 'string';
}

function isSelect(field) {
  return field.hasOwnProperty('data') && field.hasOwnProperty('choices') && typeof field.data === 'string';
}

function isMultiSelect(field) {
  return field.hasOwnProperty('data') && field.hasOwnProperty('choices') && Array.isArray(field.data);
}

function isMultiInput(field) {
  return !field.hasOwnProperty('data') && Array.isArray(field) && field.length && field[0].data && typeof field[0].data === 'string';
}

function isObject(field) {
  return !field.hasOwnProperty('data') && !Array.isArray(field) && !isMultiCheckbox(field);
}

function flattenObject(obj) {
  var toReturn = {};
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[i]) == 'object' && !Array.isArray(obj[i])) {
      var flatObject = flattenObject(obj[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = obj[i];
    }
  }
  return toReturn;
}

function findNodeByPath(tree, path) {
  return path.reduce(function (acc, item) {
    if (acc && acc.children) {
      return acc.children.find(function (node) {
        return node.path === item;
      });
    } else {
      return acc.find(function (node) {
        return node.path === item;
      });
    }
  }, tree);
}

function isBonusCurrencyMap(field) {
  var rows = field && field.hasOwnProperty('prototype') ? field.data : field;
  return Array.isArray(rows) && rows.length > 0 && rows[0] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rows[0]) === 'object' && rows[0].currency && rows[0].currency.hasOwnProperty('data');
}

function serializeBonusCurrencyMap(field) {
  var rows = field.hasOwnProperty('prototype') ? field.data || [] : field.data || field;
  return rows.map(function (row) {
    var out = {};
    for (var key in row) {
      if (row.hasOwnProperty(key)) {
        out[key] = row[key].data;
      }
    }
    return out;
  });
}

/***/ }),

/***/ "PuRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__ = __webpack_require__("gGau");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      providers: [],
      loading: false
    };
  },

  components: {
    empty: __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__["a" /* default */]
  },
  methods: {
    create: function create() {
      this.$router.push('/providers/new');
    },
    remove: function remove(providerId, index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].delete('providers/' + providerId).then(function () {
        _this.providers.splice(index, 1);
      }).catch(function () {});
    },
    test: function test() {
      this.providers.push({});
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('providers').then(function (resp) {
        return _this2.providers = resp.data;
      }).catch(function () {}).then(function () {
        return _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "QWal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__ = __webpack_require__("8XDQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global FileReader */




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  data: function data() {
    return {
      form: {
        name: '',
        partner: '',
        gameList: ''
      },
      uploads: [],
      errors: {},
      partners: {}
    };
  },

  watch: {
    uploads: function uploads(val) {
      this.handleFileUpload(val);
    }
  },
  methods: {
    load: function load() {
      if (this.id) {
        this.loadProvider(this.id);
      }
      this.loadPartners();
    },
    loadPartners: function loadPartners() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('partners').then(function (resp) {
        _this.partners = resp.data;
      }).catch(function () {});
    },
    loadProvider: function loadProvider(providerId) {
      var _this2 = this;

      var loader = this.$loading.open();
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('providers/' + providerId).then(function (resp) {
        var provider = resp.data;
        _this2.form.name = provider.name;
        _this2.form.partner = provider.partner.id;
      }).catch(function () {}).then(function () {
        loader.close();
      });
    },
    handleFileUpload: function handleFileUpload(file) {
      var _this3 = this;

      var reader = new FileReader();
      reader.onload = function () {
        _this3.form.gameList = reader.result;
      };
      reader.readAsDataURL(file);
    },
    submit: function submit() {
      var _this4 = this;

      var body = this.form;
      var request = this.id ? __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].put('providers/' + this.id, body) : __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].post('providers', body);

      request.then(function () {
        _this4.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["b" /* success */])());
      }).catch(function (errors) {
        _this4.errors = errors.response.data;
        _this4.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["a" /* error */])());
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "Qwh+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQ4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Registration Type","horizontal":""}},[_c('b-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.choices),function(choice){return _c('option',{key:choice,domProps:{"value":choice}},[_vm._v(_vm._s(choice))])}))],1)}
var staticRenderFns = []


/***/ }),

/***/ "SQlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.data && _vm.data.length)?_c('table',{staticClass:"table is-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(rule,index){return _c('tr',{key:index},[_c('td',[_c('b-field',{attrs:{"type":_vm.hasConditionError(index) ? 'is-danger' : '',"message":_vm.conditionError(index)}},[_c('b-select',{staticClass:"is-empty",attrs:{"placeholder":"Select one"},model:{value:(rule.condition.data),callback:function ($$v) {_vm.$set(rule.condition, "data", $$v)},expression:"rule.condition.data"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select One")]),_vm._v(" "),_vm._l((_vm.conditionChoices),function(choice){return _c('option',{key:choice.value,domProps:{"value":choice.value}},[_vm._v("\n                "+_vm._s(choice.label)+"\n              ")])})],2)],1)],1),_vm._v(" "),_c('td',[_c('b-select',{staticClass:"is-empty",attrs:{"placeholder":"Select one"},model:{value:(rule.status.data),callback:function ($$v) {_vm.$set(rule.status, "data", $$v)},expression:"rule.status.data"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select One")]),_vm._v(" "),_vm._l((_vm.statusChoices),function(choice){return _c('option',{key:choice.value,domProps:{"value":choice.value}},[_vm._v("\n                "+_vm._s(_vm._f("humanize")(choice.label))+"\n              ")])})],2)],1),_vm._v(" "),_c('td',[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.removeRule(index)}}},[_c('b-icon',{attrs:{"icon":"minus"}})],1)])])}))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":_vm.addRule}},[_c('b-icon',{attrs:{"icon":"plus"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Condition")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th')])}]


/***/ }),

/***/ "Se1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-form"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('section',[_c('b-field',{attrs:{"label":"Name"}},[_c('b-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Partner"}},[_c('b-select',{attrs:{"placeholder":"Select partner"},model:{value:(_vm.form.partner),callback:function ($$v) {_vm.$set(_vm.form, "partner", $$v)},expression:"form.partner"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select partner")]),_vm._v(" "),_vm._l((_vm.partners),function(partner){return _c('option',{key:partner.id,domProps:{"value":partner.id}},[_vm._v(_vm._s(partner.name))])})],2)],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Games"}}),_vm._v(" "),_c('b-field',[_c('b-upload',{model:{value:(_vm.uploads),callback:function ($$v) {_vm.uploads=$$v},expression:"uploads"}},[_c('a',{staticClass:"button is-primary"},[_c('b-icon',{attrs:{"icon":"upload"}}),_vm._v(" "),_c('span',[_vm._v("Click to upload")])],1)]),_vm._v(" "),(_vm.uploads)?_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(_vm.uploads.name))]):_vm._e()],1)],1),_vm._v(" "),_c('input',{staticClass:"button",attrs:{"type":"submit","value":"Save"}}),_vm._v(" "),_c('router-link',{staticClass:"button submit",attrs:{"to":"/providers"}},[_vm._v("Back")])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "SwOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._l((_vm.value),function(item,index){return _c('b-field',{key:index,staticStyle:{"margin-bottom":"5px"}},[_c('b-input',{attrs:{"expanded":""},model:{value:(item.data),callback:function ($$v) {_vm.$set(item, "data", $$v)},expression:"item.data"}}),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.remove(index)}}},[_c('b-icon',{attrs:{"icon":"minus"}})],1)])],1)}),_vm._v(" "),_c('b-field',[_c('button',{staticClass:"button is-primary is-small",attrs:{"type":"button"},on:{"click":_vm.add}},[_c('b-icon',{attrs:{"icon":"plus","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v("Add")])],1)])],2)}
var staticRenderFns = []


/***/ }),

/***/ "TYSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SportsbookSource_vue__ = __webpack_require__("h7gq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3f3e7e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SportsbookSource_vue__ = __webpack_require__("wv8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wwRg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f3f3e7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SportsbookSource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3f3e7e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SportsbookSource_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3f3e7e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SportsbookSource_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U3SS":
/***/ (function(module, exports) {

module.exports = {"title":"Front Configuration Schema","description":"Schema for validating frontend configuration","$schema":"http://json-schema.org/draft-04/schema","type":"object","version":28,"properties":{"version":{"type":"number","description":"Project schema version"},"betfair.api":{"type":"string","default":"","description":"Betfair API url"},"betfair.lowLiquidityCheck.enabled":{"type":"boolean","default":false,"description":"Switch on low liquidity checker"},"betfair.lowLiquidityCheck.minTotalMatched":{"type":"integer","default":5000,"description":"Minimum total matched money in low liquidity checker"},"betfair.lowLiquidityCheck.minTotalAvailable":{"type":"integer","default":500,"description":"Minimum total available money in low liquidity checker"},"betfair.showLiquidityEverywhere":{"type":"boolean","default":true,"description":"Show betfair liquidity everywhere"},"betfair.prefixUrl":{"type":"string","default":"/exchange","description":"Betfair route namespace"},"betfair.prelive.enabled":{"type":"boolean","default":true,"description":"Betfair prelive enabled"},"betfair.prelive.title":{"type":"string","default":"Home","description":"Betfair prelive title"},"betfair.live.enabled":{"type":"boolean","default":true,"description":"Betfair live enabled"},"betfair.live.title":{"type":"string","default":"Inplay","description":"Betfair live title"},"betfair.betslip.submitDelay":{"type":"integer","default":0,"description":"Betfair bet submit delay (ms)"},"bts.printUrl":{"type":"string","default":"https://dev.sbpdf.bettings.ch","description":"Sportsline print api url"},"btsAdmin.url":{"type":"string","default":"https://dev.bts-admin.bettings.ch","description":"Url of bts admin for bets urls"},"competition.api":{"type":"string","default":"","description":"Competition API url"},"competition.source":{"type":"integer","default":0,"description":"Competition's sportline source (e.g. ogbets)"},"currencies.visible":{"type":"boolean","default":true,"description":"Shows if available currencies are displayed in admin panel"},"dabba.api":{"type":"string","default":"","description":"Dabba API url"},"dabba.prefixUrl":{"type":"string","default":"/exchange","description":"Dabba route namespace"},"dabba.prelive.enabled":{"type":"boolean","default":true,"description":"Is dabba prelive enabled"},"dabba.prelive.title":{"type":"string","default":"Home","description":"Dabba prelive title"},"dabba.live.enabled":{"type":"boolean","default":true,"description":"Is dabba live enabled"},"dabba.live.title":{"type":"string","default":"Inplay","description":"Dabba live title"},"dabba.showLiquidityEverywhere":{"type":"boolean","default":true,"description":"Show dabba liquidity everywhere"},"dabba.betslip.submitDelay":{"type":"integer","default":0,"description":"Dabba bet submit delay (ms)"},"exchange.api":{"type":"string","default":"","description":"Exchange API url"},"exchange.sources":{"default":[],"description":"Exchange sources"},"exchange.showLiquidityEverywhere":{"type":"boolean","default":true,"description":"Exchange show liquidity everywhere"},"exchange.betslip.submitDelay":{"type":"integer","default":0,"description":"Exchange bet submit delay (ms)"},"exchanges.bets.defaults.enabled":{"type":"boolean","default":false,"description":"Show one click betting block in betslip"},"exchanges.bets.quick.enabled":{"type":"boolean","default":false,"description":"Show quick bets block in exchange betslip"},"exchanges.bets.confirm.enabled":{"type":"boolean","default":true,"description":"Add confirmation block before placing bet"},"exchanges.bets.confirm.default":{"type":"boolean","default":true,"description":"Default value of confirmation block before placing bet"},"exchanges.markets.open.count":{"type":"integer","default":4,"description":"Count of open markets on event page"},"exchanges.multimarkets.enabled":{"type":"boolean","default":true,"description":"User's ability to add favorite markets"},"exchanges.realLiquidity.show":{"type":"boolean","default":false,"description":"Show real liquidity"},"indexRoute":{"type":"string","default":"prelive","description":"Alias for default route of the application","minLength":1},"login.termsCheck":{"type":"boolean","default":false,"description":"Show checkbox with terms on login page"},"login.required":{"type":"boolean","default":false,"description":"Is it necessary to log in to open website?"},"matchbook.api":{"type":"string","default":"","description":"Matchbook API url"},"matchbook.prefixUrl":{"type":"string","default":"/exchange","description":"Matchbook route namespace"},"matchbook.prelive.enabled":{"type":"boolean","default":true,"description":"Is matchbook prelive enabled"},"matchbook.prelive.title":{"type":"string","default":"Home","description":"Matchbook prelive title"},"matchbook.live.enabled":{"type":"boolean","default":true,"description":"Is matchbook live enabled"},"matchbook.live.title":{"type":"string","default":"Inplay","description":"Matchbook live title"},"matchbook.showLiquidityEverywhere":{"type":"boolean","default":true,"description":"Matchbook show liquidity everywhere"},"matchbook.betslip.submitDelay":{"type":"integer","default":0,"description":"Matchbook bet submit delay (ms)"},"oneClickBetting.enabled":{"type":"boolean","default":false,"description":"Shows if one click betting is enabled"},"permissions":{},"poolbetting.api":{"type":"string","default":"","description":"Pool betting API url"},"poolbetting.adminToken":{"type":"string","default":"","description":"Pool betting API admin token"},"poolbetting.betslip.submitDelay":{"type":"integer","default":0,"description":"Pool betting bet submit delay (ms)"},"registration.type":{"type":"string","default":"basic","enum":["basic","agent"],"description":"Commonly basic registration used for sportsbook sites and agent - for exchange sites"},"registration.passwordStrength":{"type":"string","default":"low","enum":["low","medium","height"],"description":"Level of password security"},"services.recaptcha.key":{"type":"string","default":"","description":"Recaptcha key"},"services.googleAnalytics.key":{"type":"string","default":"","description":"Google analytics key"},"sessionGames.api":{"type":"string","default":"","description":"Session Games API url"},"sessionGames.adminToken":{"type":"string","default":"","description":"Token for session games requests from darkend"},"sessionGames.automateGames":{"type":"boolean","default":true,"description":"Shows if games are automated"},"sessionGames.betslip.submitDelay":{"type":"integer","default":0,"description":"Session games bet submit delay (ms)"},"sportsbook.api":{"type":"string","default":"","description":"Sportsbook API url"},"sportsbook.sources":{"default":[],"description":"Sportsbook sources"},"sportsbook.betslip.parlayLimit":{"type":"integer","default":20,"description":"Maximum count of selections in parlay","minimum":2},"sportsbook.betslip.doubleChanceLimit":{"type":"boolean","default":true,"description":"Use double chance markets restriction"},"sportsbook.betslip.maxStake":{"type":"boolean","default":false,"description":"Shows is Max Stake button is displayed"},"sportsbook.betslip.submitDelay":{"type":"integer","default":0,"description":"Sportsbook bet submit delay (ms)"},"streak.api":{"type":"string","default":"","description":"Streak API url"},"streak.token":{"type":"string","default":"","description":"Streak token"},"theme":{"type":"string","default":"","description":"Project theme","minLength":1},"translations.api":{"type":"string","default":"https://i18n.bettings.ch","description":"Api url for translation's service","minLength":1},"translations.token":{"type":"string","default":"","description":"Token for translation's service","minLength":1},"user.fields":{"type":"object","description":"User account fields"},"verification.notification":{"type":"boolean","default":false,"description":"Shows if user needs to be notified of incomplete verification"},"responsibleGambling":{"type":"boolean","default":false,"description":"Add availiability for user to do self exclusion"},"displayCurrency":{"type":"boolean","default":true,"description":"Is currency displayed"},"neverBounce.apiKey":{"type":"string","default":"","description":"Private api key for neverBounce widget"},"intercom.publicAppId":{"type":"string","default":"","description":"Public api key for intercom on the frontend"},"intercom.options":{"type":"array","items":{"type":"string"},"default":[],"description":"Which data you should send to intercom"}},"widgets.matchProgress":{"type":"string","default":"","description":"Token for match progress widget"},"moneyTransfer.enabled":{"type":"boolean","default":false,"description":"Add money transfer"}}

/***/ }),

/***/ "VDn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.fieldPayload.currencies.data.length)?_c('table',{staticClass:"table is-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.fieldPayload.currencies.data),function(currency){return _c('tr',{key:currency},[_c('td',[_vm._v(_vm._s(currency))]),_vm._v(" "),_c('td',[_c('b-input',{model:{value:(_vm.value[currency].merchantKey.data),callback:function ($$v) {_vm.$set(_vm.value[currency].merchantKey, "data", $$v)},expression:"value[currency].merchantKey.data"}})],1),_vm._v(" "),_c('td',[_c('b-input',{model:{value:(_vm.value[currency].merchantCode.data),callback:function ($$v) {_vm.$set(_vm.value[currency].merchantCode, "data", $$v)},expression:"value[currency].merchantCode.data"}})],1)])}))]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Wallet")]),_vm._v(" "),_c('th',[_vm._v("Merchant Key")]),_vm._v(" "),_c('th',[_vm._v("Merchant Code")])])}]


/***/ }),

/***/ "Vi6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__ = __webpack_require__("gGau");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      paymentMethods: [],
      loading: false
    };
  },

  components: {
    empty: __WEBPACK_IMPORTED_MODULE_1__lib_components_Empty__["a" /* default */]
  },
  methods: {
    create: function create() {
      this.$router.push('/payment_methods/new');
    },
    remove: function remove(paymentMethodId, index) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].delete('payment_methods/' + paymentMethodId).then(function () {
        _this.paymentMethods.splice(index, 1);
      }).catch(function () {});
    },
    load: function load() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('payment_methods').then(function (resp) {
        return _this2.paymentMethods = resp.data;
      }).catch(function () {}).then(function () {
        return _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "VyXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-textarea',
  props: ['value', 'type']
});

/***/ }),

/***/ "Wul2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-checkbox',
  props: ['value']
});

/***/ }),

/***/ "XG1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonschema__ = __webpack_require__("7HRn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonschema___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonschema__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path__ = __webpack_require__("SeUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_object__ = __webpack_require__("7m8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_toast__ = __webpack_require__("8XDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavItem__ = __webpack_require__("Bulm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tree__ = __webpack_require__("qOup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Frontend_Schema_json__ = __webpack_require__("U3SS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Frontend_Schema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Frontend_Schema_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Frontend_migrate__ = __webpack_require__("qPFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__("Ogkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  data: function data() {
    return {
      loaded: false,
      form: {},
      errors: {
        frontConfiguration: {}
      },
      tree: __WEBPACK_IMPORTED_MODULE_9__tree__["a" /* default */]
    };
  },

  components: {
    NavItem: __WEBPACK_IMPORTED_MODULE_8__NavItem__["a" /* default */]
  },
  computed: {
    path: function path() {
      var hash = this.$route.hash.slice(1) || 'general';
      return hash.split('/');
    },
    currentNode: function currentNode() {
      return Object(__WEBPACK_IMPORTED_MODULE_12__helpers__["a" /* findNodeByPath */])(this.tree, this.path);
    },
    errorsPaths: function errorsPaths() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(Object(__WEBPACK_IMPORTED_MODULE_12__helpers__["b" /* flattenObject */])(this.errors));
    },
    domain: function domain() {
      return this.form.domain[0] && this.form.domain[0].data || '';
    }
  },
  methods: {
    flushCache: function flushCache() {
      var domain = this.form.domain[0] && this.form.domain[0].data || '';
      var one = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=1&config=Ed[MDB7X!MZn}Zd&type=main');
      var two = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=2&config=Ed[MDB7X!MZn}Zd');
      var three = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=3&config=Ed[MDB7X!MZn}Zd');
      var four = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=4&config=Ed[MDB7X!MZn}Zd');
      var loader = this.$loading.open();
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.all([one, two, three, four]).then(__WEBPACK_IMPORTED_MODULE_13_axios___default.a.spread(function () {
        var responseOne = arguments.length <= 0 ? undefined : arguments[0];
        var responseTwo = arguments.length <= 1 ? undefined : arguments[1];
        var responesThree = arguments.length <= 2 ? undefined : arguments[2];
        loader.close();
      })).catch(function (e) {
        loader.close();
      });
    },
    flushGameCache: function flushGameCache() {
      var domain = this.form.domain[0] && this.form.domain[0].data || '';
      var one = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=1&config=Ed[MDB7X!MZn}Zd&type=games');
      var two = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=2&config=Ed[MDB7X!MZn}Zd');
      var three = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=3&config=Ed[MDB7X!MZn}Zd');
      var four = __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get('https://' + domain + '/init?s=4&config=Ed[MDB7X!MZn}Zd');
      var loader = this.$loading.open();
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.all([one, two, three, four]).then(__WEBPACK_IMPORTED_MODULE_13_axios___default.a.spread(function () {
        var responseOne = arguments.length <= 0 ? undefined : arguments[0];
        var responseTwo = arguments.length <= 1 ? undefined : arguments[1];
        var responesThree = arguments.length <= 2 ? undefined : arguments[2];
        loader.close();
      })).catch(function (e) {
        loader.close();
      });
    },
    load: function load() {
      var _this = this;

      var loader = this.$loading.open();
      var url = this.id ? 'form/projects/' + this.id : 'form/projects';
      var stage = "prod";

      __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].get(url).then(function (resp) {
        var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, resp.data);
        var frontendData = Object(__WEBPACK_IMPORTED_MODULE_11__Frontend_migrate__["a" /* default */])(data.frontConfiguration.data, stage, data.name).data;
        data.frontConfiguration.data = frontendData;

        _this.form = data;
        _this.loaded = true;
      }).catch(function (e) {
        console.log(e);
      }).then(function () {
        loader.close();
      });
    },
    submit: function submit() {
      var _this2 = this;

      var body = Object(__WEBPACK_IMPORTED_MODULE_12__helpers__["c" /* serializeForm */])(this.form);

      var result = Object(__WEBPACK_IMPORTED_MODULE_3_jsonschema__["validate"])(body.frontConfiguration, __WEBPACK_IMPORTED_MODULE_10__Frontend_Schema_json___default.a);
      if (!result.valid) {
        this.fillFrontendErrors(result);
        this.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_toast__["a" /* error */])());
        console.log(result);
        return;
      }

      var loader = this.$loading.open();
      var request = this.id ? __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].put('projects/' + this.id, body) : __WEBPACK_IMPORTED_MODULE_5__lib_utils_http__["a" /* default */].post('projects', body);
      console.log(body);

      request.then(function () {
        loader.close();
        _this2.errors = {};
        _this2.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_toast__["b" /* success */])());
      }).catch(function (errors) {
        loader.close();
        _this2.errors = errors.response && errors.response.data;
        _this2.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_toast__["a" /* error */])());
      });
    },
    fillFrontendErrors: function fillFrontendErrors(result) {
      var errors = result.errors.reduce(function (acc, error) {
        var match = error.property.match(/^instance\[\"(.*)\"\]$/);
        if (match && match[1]) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, match[1], [{ message: error.message }]);
        return acc;
      }, {});
      this.errors.frontConfiguration = { data: errors };
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "aTrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPermissions_vue__ = __webpack_require__("nFwy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af2721e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPermissions_vue__ = __webpack_require__("O4pc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dhsJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPermissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af2721e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPermissions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af2721e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPermissions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bniC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"}},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('b-field',[_c('b-input',{attrs:{"placeholder":"Project Name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-field',[_c('b-input',{attrs:{"placeholder":"Main Domain"},model:{value:(_vm.form.mainDomain),callback:function ($$v) {_vm.$set(_vm.form, "mainDomain", $$v)},expression:"form.mainDomain"}})],1)],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":_vm.duplicate}},[_vm._v("Duplicate")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Duplicate Project")])])}]


/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Projects_List_List__ = __webpack_require__("hYPb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects_Form_Form__ = __webpack_require__("lJZ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Partners_List__ = __webpack_require__("mafm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Providers_List__ = __webpack_require__("jh5s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Providers_Form__ = __webpack_require__("pjVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PaymentMethods_List__ = __webpack_require__("2yOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PaymentMethods_Form__ = __webpack_require__("/QNY");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/projects', alias: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_Projects_List_List__["a" /* default */] }, { path: '/projects/new', component: __WEBPACK_IMPORTED_MODULE_3__components_Projects_Form_Form__["a" /* default */], props: true }, { path: '/projects/:id/edit', component: __WEBPACK_IMPORTED_MODULE_3__components_Projects_Form_Form__["a" /* default */], props: true }, { path: '/partners', component: __WEBPACK_IMPORTED_MODULE_4__components_Partners_List__["a" /* default */] }, { path: '/providers', component: __WEBPACK_IMPORTED_MODULE_5__components_Providers_List__["a" /* default */] }, { path: '/providers/new', component: __WEBPACK_IMPORTED_MODULE_6__components_Providers_Form__["a" /* default */], props: true }, { path: '/providers/:id/edit', component: __WEBPACK_IMPORTED_MODULE_6__components_Providers_Form__["a" /* default */], props: true }, { path: '/payment_methods', component: __WEBPACK_IMPORTED_MODULE_7__components_PaymentMethods_List__["a" /* default */] }, { path: '/payment_methods/new', component: __WEBPACK_IMPORTED_MODULE_8__components_PaymentMethods_Form__["a" /* default */], prop: true }, {
    path: '/payment_methods/:id/edit',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PaymentMethods_Form__["a" /* default */],
    props: true
  }]
}));

/***/ }),

/***/ "dhsJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dkO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__("6c7H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bddcbeb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__("osbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bddcbeb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bddcbeb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dmiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiCheckbox_vue__ = __webpack_require__("nlXn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358ca796_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiCheckbox_vue__ = __webpack_require__("i57G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1g9O")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-358ca796"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358ca796_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiCheckbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358ca796_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiCheckbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eEJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-multi-select',
  props: ['value'],
  computed: {
    filteredChoices: function filteredChoices() {
      var _this = this;

      return this.value.choices.filter(function (choice) {
        return _this.value.data.indexOf(choice.value) === -1;
      });
    },
    items: function items() {
      var _this2 = this;

      return this.value.data.map(function (value) {
        return _this2.value.choices.find(function (c) {
          return c.value === value;
        });
      });
    }
  },
  methods: {
    add: function add(value) {
      if (this.value.data.indexOf(value) !== -1 || this.$refs.select.selected === null) return;
      var data = this.value.data.concat(value);
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value, { data: data }));
      this.$refs.select.selected = null;
    },
    remove: function remove(value) {
      var data = this.value.data.filter(function (v) {
        return v !== value;
      });
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value, { data: data }));
      this.$refs.select.selected = null;
    }
  }
});

/***/ }),

/***/ "eQ9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArrayInput_vue__ = __webpack_require__("kQCP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbd4c76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArrayInput_vue__ = __webpack_require__("EVTX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArrayInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbd4c76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArrayInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bbd4c76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArrayInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ev/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-checkbox',{staticClass:"checkbox",model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}})}
var staticRenderFns = []


/***/ }),

/***/ "fOZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'frontend-registration-password-strength',
  props: ['value'],
  data: function data() {
    return {
      choices: ['low', 'medium', 'height']
    };
  }
});

/***/ }),

/***/ "fboG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-table',{attrs:{"data":_vm.list,"loading":_vm.loading,"striped":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Name"}},[_vm._v("\n        "+_vm._s(props.row.name)+"\n      ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Actions","width":200}},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.remove(props.row.id)}}},[_vm._v("\n          Remove\n        ")])])]}}])},[(!_vm.loading)?_c('template',{slot:"empty"},[_c('empty')],1):_vm._e()],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "fw3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__("SeUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_components_Switch__ = __webpack_require__("Mddy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_components_Input__ = __webpack_require__("u/OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_components_Textarea__ = __webpack_require__("ldgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_components_Select__ = __webpack_require__("dkO4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_components_Checkbox__ = __webpack_require__("LgiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_components_TagInput__ = __webpack_require__("2/wf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_components_MultiInput__ = __webpack_require__("EVno");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_components_MultiArrayInput__ = __webpack_require__("eQ9Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_components_MultiSelect__ = __webpack_require__("A3Pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_components_MultiCheckbox__ = __webpack_require__("dmiC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Custom_ExchangeSources__ = __webpack_require__("nh2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Custom_FileManager__ = __webpack_require__("DeWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Custom_PaymentPaysecCurrenciesWallets__ = __webpack_require__("Gu1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Custom_BonusCurrencyMap__ = __webpack_require__("jXzV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Custom_SportsbookSource__ = __webpack_require__("TYSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Custom_UserFields__ = __webpack_require__("y/lZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Custom_UserPermissions__ = __webpack_require__("aTrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Custom_UserVerification__ = __webpack_require__("rEWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Frontend_RegistrationType__ = __webpack_require__("qoLf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Frontend_RegistrationPasswordStrength__ = __webpack_require__("hsuJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Frontend_IntercomOptions__ = __webpack_require__("imYw");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// Custom








// Frontend




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'field',
  props: ['value', 'field', 'errors'],
  components: {
    CSwitch: __WEBPACK_IMPORTED_MODULE_2__lib_components_Switch__["a" /* default */],
    CInput: __WEBPACK_IMPORTED_MODULE_3__lib_components_Input__["a" /* default */],
    CTextarea: __WEBPACK_IMPORTED_MODULE_4__lib_components_Textarea__["a" /* default */],
    CSelect: __WEBPACK_IMPORTED_MODULE_5__lib_components_Select__["a" /* default */],
    CCheckbox: __WEBPACK_IMPORTED_MODULE_6__lib_components_Checkbox__["a" /* default */],
    CTagInput: __WEBPACK_IMPORTED_MODULE_7__lib_components_TagInput__["a" /* default */],
    CMultiInput: __WEBPACK_IMPORTED_MODULE_8__lib_components_MultiInput__["a" /* default */],
    CMultiArrayInput: __WEBPACK_IMPORTED_MODULE_9__lib_components_MultiArrayInput__["a" /* default */],
    CMultiSelect: __WEBPACK_IMPORTED_MODULE_10__lib_components_MultiSelect__["a" /* default */],
    CMultiCheckbox: __WEBPACK_IMPORTED_MODULE_11__lib_components_MultiCheckbox__["a" /* default */],
    // Custom
    ExchangeSources: __WEBPACK_IMPORTED_MODULE_12__Custom_ExchangeSources__["a" /* default */],
    SportsbookSource: __WEBPACK_IMPORTED_MODULE_16__Custom_SportsbookSource__["a" /* default */],
    FileManager: __WEBPACK_IMPORTED_MODULE_13__Custom_FileManager__["a" /* default */],
    UserVerification: __WEBPACK_IMPORTED_MODULE_19__Custom_UserVerification__["a" /* default */],
    UserPermissions: __WEBPACK_IMPORTED_MODULE_18__Custom_UserPermissions__["a" /* default */],
    UserFields: __WEBPACK_IMPORTED_MODULE_17__Custom_UserFields__["a" /* default */],
    PaymentPaysecCurrenciesWallets: __WEBPACK_IMPORTED_MODULE_14__Custom_PaymentPaysecCurrenciesWallets__["a" /* default */],
    BonusCurrencyMap: __WEBPACK_IMPORTED_MODULE_15__Custom_BonusCurrencyMap__["a" /* default */],
    // Frontend
    IntercomOptions: __WEBPACK_IMPORTED_MODULE_22__Frontend_IntercomOptions__["a" /* default */],
    FrontendRegistrationType: __WEBPACK_IMPORTED_MODULE_20__Frontend_RegistrationType__["a" /* default */],
    FrontendRegistrationPasswordStrength: __WEBPACK_IMPORTED_MODULE_21__Frontend_RegistrationPasswordStrength__["a" /* default */]
  },
  computed: {
    data: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(this.value, this.path);
      },
      set: function set(value) {
        __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.set(this.value, this.path, value);
      }
    },
    hasError: function hasError() {
      return __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.has(this.errors, this.path);
    },
    fieldErrors: function fieldErrors() {
      return __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(this.errors, this.path);
    },
    errorMessage: function errorMessage() {
      return __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(this.errors, this.path.concat([0, 'message']));
    },
    fieldPayload: function fieldPayload() {
      var _this = this;

      if (!this.field.payload) return {};
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.field.payload).reduce(function (acc, key) {
        acc[key] = __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_this.value, _this.field.payload[key]);
        return acc;
      }, {});
    },
    path: function path() {
      // frontend configuration feature for `object-path` library
      if (this.field.path.startsWith('frontConfiguration.data')) {
        var frontPath = this.field.path.split('.').slice(2).join('.');
        return ['frontConfiguration', 'data', frontPath];
      }
      return this.field.path.split('.');
    }
  }
});

/***/ }),

/***/ "gGau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abbf094c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empty_vue__ = __webpack_require__("5QiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abbf094c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empty_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abbf094c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empty_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h3zK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._l((_vm.data),function(provider,index){return _c('div',{key:index,staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Live","horizontal":""}},[_c('b-input',{model:{value:(provider.live.source),callback:function ($$v) {_vm.$set(provider.live, "source", $$v)},expression:"provider.live.source"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Prelive","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.source),callback:function ($$v) {_vm.$set(provider.prelive, "source", $$v)},expression:"provider.prelive.source"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Url","horizontal":""}},[_c('b-input',{model:{value:(provider.live.url),callback:function ($$v) {_vm.$set(provider.live, "url", $$v)},expression:"provider.live.url"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Url","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.url),callback:function ($$v) {_vm.$set(provider.prelive, "url", $$v)},expression:"provider.prelive.url"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Name","horizontal":""}},[_c('b-input',{model:{value:(provider.live.name),callback:function ($$v) {_vm.$set(provider.live, "name", $$v)},expression:"provider.live.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Name","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.name),callback:function ($$v) {_vm.$set(provider.prelive, "name", $$v)},expression:"provider.prelive.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.removeSource(index)}}},[_c('b-icon',{attrs:{"icon":"minus"}})],1)])])}),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"horizontal":""}},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":_vm.addSource}},[_vm._v("Add source")])])],2)}
var staticRenderFns = []


/***/ }),

/***/ "h7gq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sportsbook-source',
  props: ['value'],
  data: function data() {
    return {
      types: ['betradar']
    };
  },

  computed: {
    data: function data() {
      return this.value || [];
    }
  },
  methods: {
    addSource: function addSource() {
      var newItem = {
        live: { source: '', url: '', name: '', types: [] },
        prelive: { source: '', url: '', name: '', types: [] }
      };

      if (!Array.isArray(this.value)) {
        this.$emit('input', [newItem]);
      } else {
        this.value.push(newItem);
      }
    },
    removeSource: function removeSource(index) {
      this.value.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "hNwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-input',{attrs:{"type":"textarea"},model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "hYPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("sr/Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7684a3d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("C4H2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Qwh+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7684a3d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7684a3d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hsuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPasswordStrength_vue__ = __webpack_require__("fOZu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4a9188_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPasswordStrength_vue__ = __webpack_require__("xAgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationPasswordStrength_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4a9188_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPasswordStrength_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4a9188_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationPasswordStrength_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hz3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__ = __webpack_require__("8XDQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  data: function data() {
    return {
      form: {
        name: ''
      },
      errors: {}
    };
  },

  methods: {
    loadPaymentMethod: function loadPaymentMethod(paymentMethodId) {
      var _this = this;

      var loader = this.$loading.open();

      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].get('payment_methods/' + paymentMethodId).then(function (resp) {
        var paymentMethod = resp.data;
        _this.form.name = paymentMethod.name;
      }).catch(function () {}).then(function () {
        loader.close();
      });
    },
    submit: function submit() {
      var _this2 = this;

      var body = this.form;
      var request = this.id ? __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].put('payment_methods/' + this.id, body) : __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].post('payment_methods', body);

      request.then(function () {
        _this2.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["b" /* success */])());
      }).catch(function (errors) {
        _this2.errors = errors.response.data;
        _this2.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["a" /* error */])());
      });
    }
  },
  created: function created() {
    this.loadPaymentMethod(this.id);
  }
});

/***/ }),

/***/ "i57G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkbox-list"},_vm._l((_vm.value),function(checkbox){return _c('b-checkbox',{key:checkbox.label,model:{value:(checkbox.data),callback:function ($$v) {_vm.$set(checkbox, "data", $$v)},expression:"checkbox.data"}},[_vm._v("\n    "+_vm._s(checkbox.label)+"\n  ")])}))}
var staticRenderFns = []


/***/ }),

/***/ "iPiz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('button',{staticClass:"button field is-primary pull-right",on:{"click":_vm.create}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" "),_c('span',[_vm._v("New")])],1),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.paymentMethods,"loading":_vm.loading,"striped":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Name","field":"name"}},[_vm._v("\n        "+_vm._s(props.row.name)+"\n      ")]),_vm._v(" "),_c('b-table-column',{attrs:{"label":"Actions","width":200}},[_c('router-link',{attrs:{"to":("/payment_methods/" + (props.row.id) + "/edit")}},[_c('button',{staticClass:"button"},[_vm._v("Edit")])]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){$event.preventDefault();_vm.remove(props.row.id, props.index)}}},[_vm._v("Remove")])],1)]}}])},[(!_vm.loading)?_c('template',{slot:"empty"},[_c('empty')],1):_vm._e()],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "igua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-switch',{model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}})}
var staticRenderFns = []


/***/ }),

/***/ "imYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntercomOptions_vue__ = __webpack_require__("9NKt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1dbc0e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntercomOptions_vue__ = __webpack_require__("xPB2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntercomOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1dbc0e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntercomOptions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1dbc0e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntercomOptions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jXzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusCurrencyMap_vue__ = __webpack_require__("Fa6E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6371c480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusCurrencyMap_vue__ = __webpack_require__("F2SA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusCurrencyMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6371c480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusCurrencyMap_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6371c480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusCurrencyMap_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jh5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("PuRL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a86d5f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("5kAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a86d5f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a86d5f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exchange-sources',
  props: ['value'],
  computed: {
    data: function data() {
      return this.value || [];
    }
  },
  methods: {
    addSource: function addSource() {
      var newItem = {
        live: { source: '', url: '', name: '' },
        prelive: { source: '', url: '', name: '' }
      };

      if (Array.isArray(this.value)) {
        this.value.push(newItem);
      } else {
        this.$emit('input', [newItem]);
      }
    },
    removeSource: function removeSource(index) {
      this.value.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "kOaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/"}},[_c('b-icon',{attrs:{"icon":"home"}})],1),_vm._v(" "),_c('div',{class:['navbar-burger burger', { 'is-active': _vm.burger }],on:{"click":function($event){_vm.burger = !_vm.burger}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])],1),_vm._v(" "),_c('div',{class:['navbar-menu', { 'is-active': _vm.burger }],attrs:{"id":"navbarMenu"}},[_c('div',{staticClass:"navbar-start"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/projects"}},[_vm._v("Projects")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/providers"}},[_vm._v("Providers")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/partners"}},[_vm._v("Partners")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/payment_methods"}},[_vm._v("Payment Methods")])],1)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-view')],1)])}
var staticRenderFns = []


/***/ }),

/***/ "kQCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-multi-array-input',
  props: ['value'],
  data: function data() {
    return {
      data: this.value.data || this.value
    };
  },

  methods: {
    add: function add() {
      this.data.push({
        host: {
          data: ''
        },
        port: {
          data: ''
        },
        dbname: {
          data: ''
        },
        user: {
          data: ''
        },
        password: {
          data: ''
        }
      });
    },
    remove: function remove(index) {
      this.data.splice(index, 1);
    }
  }
});

/***/ }),

/***/ "l6/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l9Xd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lJZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("XG1a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a638e64a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("OMPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zOiR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a638e64a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a638e64a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a638e64a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ldgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textarea_vue__ = __webpack_require__("VyXx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff57143_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textarea_vue__ = __webpack_require__("hNwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff57143_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textarea_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff57143_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textarea_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mafm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("2Hui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791a65cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("fboG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791a65cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791a65cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nFwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-user-permissions',
  props: ['value'],
  data: function data() {
    return {
      activePresetType: null,
      activeUserTypes: [],
      userTypes: ['guest', 'player', 'manager', 'agentplayer', 'masteragent', 'supermasteragent'],
      presetTypes: ['sportsbook', 'shop', 'exchange'],
      actions: ['seeLoginForm', 'seeRegistrationPage', 'seeBalanceLink', 'seeAccountLink', 'seeAccountPage', 'seeLogoutLink', 'placeBet'],
      emptyUserData: {
        defaultRoute: '/',
        actions: []
      }
    };
  },

  computed: {
    derivedValue: function derivedValue() {
      var _this = this;

      this.userTypes.forEach(function (userType) {
        if (!_this.hasUserType(_this.value, userType)) {
          _this.setEmptyUser(_this.value, userType);
        }
      });
      return this.value;
    },
    emptyValue: function emptyValue() {
      var _this2 = this;

      return this.userTypes.reduce(function (value, userType) {
        return _this2.setEmptyUser(value, userType);
      }, {});
    }
  },
  methods: {
    changePresetType: function changePresetType(presetType) {
      var presets = {
        sportsbook: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm', 'seeRegistrationPage']
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink']
          }
        },
        shop: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm']
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink']
          },
          manager: {
            defaultRoute: '/',
            actions: ['seeBalanceLink', 'seeLogoutLink']
          }
        },
        exchange: {
          guest: {
            defaultRoute: '/',
            actions: ['seeLoginForm']
          },
          player: {
            defaultRoute: '/',
            actions: ['placeBet', 'seeAccountLink', 'seeAccountPage', 'seeBalanceLink', 'seeLogoutLink']
          }
        }
      };

      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, presets[presetType]));
    },
    isUserTypeActive: function isUserTypeActive(userType) {
      return this.activeUserTypes.includes(userType);
    },
    hasUserType: function hasUserType(value, userType) {
      return value[userType] && value[userType].defaultRoute && value[userType].actions;
    },
    setEmptyUser: function setEmptyUser(value, userType) {
      value[userType] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.emptyUserData);
      return value;
    }
  }
});

/***/ }),

/***/ "nZQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_MultiSelect__ = __webpack_require__("A3Pa");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-user-verification',
  props: ['value', 'fieldPayload', 'fieldErrors'],
  data: function data() {
    return {
      status: this.value.prototype ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.value.prototype.status)) : JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.value[0].status))
    };
  },

  components: {
    CMultiSelect: __WEBPACK_IMPORTED_MODULE_1__lib_components_MultiSelect__["a" /* default */]
  },
  computed: {
    data: function data() {
      return this.value || [];
    },
    conditionChoices: function conditionChoices() {
      var _this = this;

      return this.fieldPayload.enabled.choices.filter(function (choice) {
        return _this.fieldPayload.enabled.data.indexOf(choice.value) !== -1;
      });
    },
    statusChoices: function statusChoices() {
      try {
        return this.status.choices.slice();
      } catch (e) {
        return [];
      }
    }
  },
  methods: {
    addRule: function addRule() {
      var newItem = {
        status: { data: '' },
        condition: { data: '' }
      };

      if (!Array.isArray(this.data)) {
        this.$emit('input', [newItem]);
      } else {
        this.value.push(newItem);
      }
    },
    removeRule: function removeRule(index) {
      this.value.splice(index, 1);
    },
    hasConditionError: function hasConditionError(index) {
      return Boolean(this.fieldErrors && this.fieldErrors[index] && this.fieldErrors[index].condition);
    },
    conditionError: function conditionError(index) {
      return this.hasConditionError(index) ? this.fieldErrors[index].condition[0].message : '';
    }
  }
});

/***/ }),

/***/ "nh2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExchangeSources_vue__ = __webpack_require__("k8jt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9508aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExchangeSources_vue__ = __webpack_require__("h3zK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExchangeSources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9508aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExchangeSources_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9508aee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExchangeSources_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nlXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-multi-checkbox',
  props: ['value']
});

/***/ }),

/***/ "nrEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"grouped":"","group-multiline":""}},[_c('b-select',{ref:"select",attrs:{"placeholder":"Select one"},on:{"input":_vm.add}},[_c('option',{key:"empty",attrs:{"value":"","disabled":""}},[_vm._v("Select one")]),_vm._v(" "),_vm._l((_vm.filteredChoices),function(choice){return _c('option',{key:choice.value,domProps:{"value":choice.value}},[_vm._v("\n      "+_vm._s(choice.label)+"\n    ")])})],2),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.value,staticClass:"control tag-items"},[_c('b-tag',{attrs:{"type":"is-primary","attached":"","closable":""},on:{"close":function($event){_vm.remove(item.value)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])],1)})],2)}
var staticRenderFns = []


/***/ }),

/***/ "osbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{staticClass:"is-empty",attrs:{"placeholder":"Select one"},model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select One")]),_vm._v(" "),_vm._l((_vm.value.choices),function(choice){return _c('option',{key:choice.value,domProps:{"value":choice.value}},[_vm._v("\n    "+_vm._s(choice.label)+"\n  ")])})],2)}
var staticRenderFns = []


/***/ }),

/***/ "pjVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("QWal");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d540a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("Se1V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("l6/d")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d540a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d540a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qOup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payments__ = __webpack_require__("GBsj");



/* harmony default export */ __webpack_exports__["a"] = ([{
  label: 'General',
  path: 'general',
  fields: [{ label: 'Name', type: 'c-input', path: 'name' }, { label: 'Locale', type: 'c-select', path: 'locale' }, { label: 'Secret', type: 'c-input', path: 'secret' }, { label: 'Https', type: 'c-switch', path: 'https' }, { label: 'Domains', type: 'c-tag-input', path: 'domain' }, { label: 'Custom Config', type: 'c-switch', path: 'customConfig' }]
}, {
  label: 'Project',
  path: 'project',
  fields: [{ label: 'Name', type: 'c-input', path: 'core.configuration.project.name' }, { label: 'Locale', type: 'c-select', path: 'core.configuration.project.locale' }, { label: 'Locales', type: 'c-multi-select', path: 'core.configuration.project.locales' }, { label: 'Odds Format', type: 'c-select', path: 'core.configuration.project.odds_format' }, { label: 'Session Duration', type: 'c-input', path: 'core.configuration.project.session_duration' }, { label: 'Items on Page', type: 'c-input', path: 'core.configuration.on_page' }, { label: 'Index Route', type: 'b-input', path: 'frontConfiguration.data.indexRoute' }, { label: 'Theme', type: 'b-input', path: 'frontConfiguration.data.theme' }, {
    label: 'Backend Conf Cache',
    type: 'c-switch',
    path: 'core.configuration.project.cachedConfiguration'
  }, {
    label: 'Translations',
    fields: [{ label: 'URL', type: 'b-input', path: 'frontConfiguration.data.translations.api' }, { label: 'Token', type: 'b-input', path: 'frontConfiguration.data.translations.token' }]
  }]
}, {
  label: 'Database',
  path: 'database',
  fields: [{ label: 'Host', type: 'c-input', path: 'database.host' }, { label: 'Port', type: 'c-input', path: 'database.port' }, { label: 'Name', type: 'c-input', path: 'database.name' }, { label: 'User', type: 'c-input', path: 'database.user' }, { label: 'Password', type: 'c-input', path: 'database.password' }, { label: 'Slaves', type: 'c-multi-array-input', path: 'database.slaves' }]
}, {
  label: 'Frontend',
  path: 'frontend',
  fields: [{ label: 'Admin Path', type: 'c-input', path: 'frontend.admin' }, { label: 'Frontend Path', type: 'c-input', path: 'frontend.frontend' }, {
    label: 'Exchange',
    fields: [{ label: 'Enabled', type: 'c-switch', path: 'frontend.exchange.enabled' }, { label: 'Path', type: 'c-input', path: 'frontend.exchange.path' }]
  }, {
    label: 'Mobile',
    fields: [{ label: 'Enabled', type: 'c-switch', path: 'frontend.mobile.enabled' }, { label: 'Path', type: 'c-input', path: 'frontend.mobile.path' }]
  }, {
    label: 'Agent System',
    fields: [{ label: 'Enabled', type: 'c-switch', path: 'frontend.agent.enabled' }, { label: 'Path', type: 'c-input', path: 'frontend.agent.path' }]
  }, {
    label: 'Partner System',
    fields: [{ label: 'Enabled', type: 'c-switch', path: 'frontend.partner.enabled' }, { label: 'Path', type: 'c-input', path: 'frontend.partner.path' }]
  }]
}, {
  label: 'Currencies',
  path: 'currencies',
  fields: [{ label: 'Rate', type: 'c-select', path: 'core.configuration.currency.rate' }, { label: 'Default', type: 'c-select', path: 'core.configuration.currency.default' }, { label: 'View', type: 'c-multi-select', path: 'core.configuration.currency.view' }, { label: 'Available', type: 'c-multi-select', path: 'core.configuration.currency.available' }]
}, { label: 'Payments', path: 'payments', enabledPath: 'payment.enabled', children: __WEBPACK_IMPORTED_MODULE_1__payments__["a" /* default */] }, {
  label: 'Modules',
  path: 'modules',
  children: [{
    label: 'Admin',
    path: 'admin',
    fields: [{ label: 'TFA Enabled', type: 'c-switch', path: 'admin.configuration.tfa_enabled' }, { label: 'TFA on Withdraw', type: 'c-switch', path: 'admin.configuration.tfa_on_withdraw' }, { label: 'Show Currencies', type: 'b-switch', path: 'frontConfiguration.data.currencies.visible' }]
  }, {
    label: 'Exchange Settings',
    path: 'exchange-settings',
    fields: [{
      label: 'Enable Multimarkets',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.multimarkets.enabled'
    }, {
      label: 'Enable Quick Bets',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.bets.quick.enabled'
    }, {
      label: 'Enable Bet Confirm',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.bets.confirm.enabled'
    }, {
      label: 'Default Bet Confirm',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.bets.confirm.default'
    }, {
      label: 'Enable Default Bets',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.bets.defaults.enabled'
    }, {
      label: 'Show Real Liquidity',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchanges.realLiquidity.show'
    }, {
      label: 'Open Markets Count',
      type: 'c-input',
      path: 'frontConfiguration.data.exchanges.markets.open.count'
    }]
  }, { label: 'Agent System', path: 'agent', enabledPath: 'agent.enabled' }, {
    label: 'Achievements',
    path: 'achievements',
    enabledPath: 'achievement.enabled',
    fields: [{
      label: 'Win Points',
      fields: [{ label: 'Enabled', type: 'c-switch', path: 'achievement.configuration.win_points.enabled' }, { label: 'Percent', type: 'c-input', path: 'achievement.configuration.win_points.percent' }, { label: 'Min Stake', type: 'c-input', path: 'achievement.configuration.win_points.stake_min' }]
    }]
  }, {
    label: 'Achievements2',
    path: 'achievements2',
    enabledPath: 'achievement2.enabled',
    fields: [{ label: 'Frontend Enabled', type: 'b-switch', path: 'frontConfiguration.data.achievements2.api' }]
  }, {
    label: 'Lottery',
    path: 'millioner',
    enabledPath: 'millioner.enabled',
    fields: []
  }, {
    label: 'messenger',
    path: 'messenger',
    enabledPath: 'messenger.enabled',
    fields: []
  }, {
    label: 'Freebet',
    path: 'freebet',
    enabledPath: 'freebet.enabled',
    fields: []
  }, {
    label: 'Betfair',
    path: 'betfair',
    enabledPath: 'betfair.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'betfair.configuration.api' }, { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.betfair.api' }, { label: 'Account ID', type: 'c-input', path: 'betfair.configuration.account_id' }, { label: 'Commission', type: 'c-input', path: 'betfair.configuration.commission' }, { label: 'Manual', type: 'c-switch', path: 'betfair.configuration.manual' }, { label: 'Exposure Limit', type: 'c-input', path: 'betfair.configuration.exposure_limit' }, {
      label: 'Exposure Limit Enabled',
      type: 'c-switch',
      path: 'betfair.configuration.exposure_limit_enabled'
    }, {
      label: 'Low Liquidity Check',
      fields: [{
        label: 'Enabled',
        type: 'b-switch',
        path: 'frontConfiguration.data.betfair.lowLiquidityCheck.enabled'
      }, {
        label: 'Min Total Available',
        type: 'c-input',
        valueType: 'integer',
        path: 'frontConfiguration.data.betfair.lowLiquidityCheck.minTotalAvailable'
      }, {
        label: 'Min Total Matched',
        type: 'c-input',
        valueType: 'integer',
        path: 'frontConfiguration.data.betfair.lowLiquidityCheck.minTotalMatched'
      }]
    }, {
      label: 'Show Liquidity Everywhere',
      type: 'b-switch',
      path: 'frontConfiguration.data.betfair.showLiquidityEverywhere'
    }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getExchangeSettings('betfair')))
  }, {
    label: 'Dabba',
    path: 'dabba',
    enabledPath: 'dabba.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'dabba.configuration.api' }, { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.dabba.api' }, { label: 'Account Id', type: 'c-input', path: 'dabba.configuration.account_id' }, { label: 'Admin Token', type: 'c-input', path: 'dabba.configuration.admin_token' }, {
      label: 'Show Liquidity Everywhere',
      type: 'b-switch',
      path: 'frontConfiguration.data.betfair.showLiquidityEverywhere'
    }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getExchangeSettings('dabba')))
  }, {
    label: 'Exchange',
    path: 'exchange',
    enabledPath: 'exchange.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'exchange.configuration.api' }, { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.exchange.api' }, { label: 'Token', type: 'c-input', path: 'exchange.configuration.token' }, { label: 'Commission', type: 'c-input', path: 'exchange.configuration.commission' }, {
      label: 'Sources',
      fields: [{ type: 'exchange-sources', path: 'frontConfiguration.data.exchange.sources' }]
    }, {
      label: 'Bet Submit Delay (ms)',
      type: 'c-input',
      valueType: 'integer',
      path: 'frontConfiguration.data.exchange.betslip.submitDelay'
    }, {
      label: 'Show Liquidity Everywhere',
      type: 'b-switch',
      path: 'frontConfiguration.data.exchange.showLiquidityEverywhere'
    }]
  }, {
    label: 'Darwin ',
    path: 'darwin',
    enabledPath: 'darwin.enabled',
    fields: [{ label: 'Password', type: 'c-input', path: 'darwin.configuration.password' }, { label: 'Username', type: 'c-input', path: 'darwin.configuration.username' }, { label: 'Casino Id', type: 'c-input', path: 'darwin.configuration.casino_id' }, { label: 'Lobby Url', type: 'c-input', path: 'darwin.configuration.lobbyUrl' }]
  }, {
    label: 'Huidu ',
    path: 'huidu',
    enabledPath: 'huidu.enabled',
    fields: [{ label: 'UID', type: 'c-input', path: 'huidu.configuration.agency_uid' }, { label: 'AES', type: 'c-input', path: 'huidu.configuration.aes_key' }, { label: 'Server URL', type: 'c-input', path: 'huidu.configuration.server_url' }, { label: 'Language', type: 'c-input', path: 'huidu.configuration.language' }, { label: 'Prefix', type: 'c-input', path: 'huidu.configuration.prefix' }]
  }, {
    label: 'Jili',
    path: 'ji_li',
    enabledPath: 'ji_li.enabled',
    fields: [{ label: 'Agent Key', type: 'c-input', path: 'ji_li.configuration.agent_key' }, { label: 'Api Url', type: 'c-input', path: 'ji_li.configuration.api_url' }, { label: 'Language', type: 'c-input', path: 'ji_li.configuration.lang' }, { label: 'Agent Id', type: 'c-input', path: 'ji_li.configuration.agent_id' }]
  }, {
    label: 'Session Games',
    path: 'session-games',
    enabledPath: 'session_games.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'session_games.configuration.api' }, { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.sessionGames.api' }, { label: 'Token', type: 'c-input', path: 'session_games.configuration.token' }, {
      label: 'Admin Token',
      type: 'b-input',
      path: 'frontConfiguration.data.sessionGames.adminToken'
    }, {
      label: 'Automate',
      type: 'b-switch',
      path: 'frontConfiguration.data.sessionGames.automateGames'
    }, {
      label: 'Bet submit delay (ms)',
      type: 'c-input',
      valueType: 'integer',
      path: 'frontConfiguration.data.sessionGames.betslip.submitDelay'
    }]
  }, {
    label: 'Bolobhai',
    path: 'bolobhai',
    enabledPath: 'bolobhai.enabled',
    fields: [{
      label: 'Api URL',
      type: 'c-input',
      path: 'bolobhai.configuration.api'
    }, {
      label: 'Casino ID',
      type: 'c-input',
      valueType: 'integer',
      path: 'bolobhai.configuration.casino_id'
    }, {
      label: 'Secret Key',
      type: 'c-input',
      path: 'bolobhai.configuration.secret_key'
    }]
  }, {
    label: 'Spribe',
    path: 'spribe',
    enabledPath: 'spribe.enabled',
    fields: [{
      label: 'Api URL',
      type: 'c-input',
      path: 'spribe.configuration.api'
    }, {
      label: 'Secret Key',
      type: 'c-input',
      path: 'spribe.configuration.secret_key'
    }, {
      label: 'Operator ID',
      type: 'c-input',
      path: 'spribe.configuration.operator_id'
    }, {
      label: 'Launch URL',
      type: 'c-input',
      path: 'spribe.configuration.launch_url'
    }]
  }, {
    label: 'TurboSports',
    path: 'turbo_sports',
    enabledPath: 'turbo_sports.enabled',
    fields: [{
      label: 'CID',
      type: 'c-input',
      path: 'turbo_sports.configuration.cid'
    }, {
      label: 'Secret Key',
      type: 'c-input',
      path: 'turbo_sports.configuration.secret_key'
    }, {
      label: 'Api URL',
      type: 'c-input',
      path: 'turbo_sports.configuration.api_url'
    }]
  }, {
    label: 'Fancy Games',
    path: 'fancy-games',
    enabledPath: 'fancy_games.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'fancy_games.configuration.api' }, { label: 'Token', type: 'c-input', path: 'fancy_games.configuration.token' }, { label: 'Secret Key', type: 'c-input', path: 'fancy_games.configuration.secret_key' }, {
      label: 'Base Url Linking Events',
      type: 'c-input',
      path: 'fancy_games.configuration.base_url_linking_events'
    }]
  }, {
    label: 'Sportsbook',
    path: 'sportsbook',
    enabledPath: 'sport_book.enabled',
    fields: [{ label: 'Admin URL', type: 'c-input', path: 'sport_book.configuration.admin' }, { label: 'Api URL', type: 'c-input', path: 'sport_book.configuration.api' }, { label: 'Frontend Api URL', type: 'c-input', path: 'frontConfiguration.data.sportsbook.api' }, { label: 'Print URL', type: 'c-input', path: 'frontConfiguration.data.bts.printUrl' }, { label: 'Token', type: 'c-input', path: 'sport_book.configuration.token' }, { label: 'MTS Limit ID', type: 'c-input', path: 'sport_book.configuration.mts_limit_id' }, { label: 'Parlay Bonus', type: 'c-switch', path: 'sport_book.configuration.bonus_parlay' }, { label: 'Cancelable', type: 'c-switch', path: 'sport_book.configuration.cancelled' }, {
      label: 'Sources',
      fields: [{ type: 'sportsbook-source', path: 'frontConfiguration.data.sportsbook.sources' }]
    }, {
      label: 'Bet Submit Delay (ms)',
      type: 'c-input',
      valueType: 'integer',
      path: 'frontConfiguration.data.sportsbook.betslip.submitDelay'
    }, {
      label: 'Parlay Limit',
      type: 'c-input',
      valueType: 'integer',
      path: 'frontConfiguration.data.sportsbook.betslip.parlayLimit'
    }, {
      label: 'Double Chance Limit',
      type: 'b-switch',
      path: 'frontConfiguration.data.sportsbook.betslip.doubleChanceLimit'
    }, {
      label: 'Max Stake',
      type: 'b-switch',
      path: 'frontConfiguration.data.sportsbook.betslip.maxStake'
    }]
  }, {
    label: 'SportsLotto',
    path: 'sports_lotto',
    enabledPath: 'sports_lotto.enabled',
    fields: [{ label: 'Api URL', type: 'c-input', path: 'sports_lotto.configuration.api' }]
  }, { label: 'Flash Games', path: 'flash-games', enabledPath: 'flash_games.enabled' }, {
    label: 'SoftSwiss',
    path: 'softswiss',
    enabledPath: 'soft_swiss.enabled',
    fields: [{ label: 'Backend URL', type: 'c-input', path: 'soft_swiss.configuration.backendUrl' }, { label: 'Script URL', type: 'c-input', path: 'soft_swiss.configuration.scriptUrl' }, { label: 'Auth Token', type: 'c-input', path: 'soft_swiss.configuration.authToken' }, { label: 'Casino ID', type: 'c-input', path: 'soft_swiss.configuration.casinoId' }, { label: 'Providers', type: 'c-multi-checkbox', path: 'softSwissProviders' }]
  }, {
    label: 'XPG Casino',
    path: 'xpg_casino',
    enabledPath: 'xpg_casino.enabled',
    fields: [{ label: 'API url', type: 'c-input', path: 'xpg_casino.configuration.api_url' }, { label: 'Name', type: 'c-input', path: 'xpg_casino.configuration.name' }, { label: 'Operator id', type: 'c-input', path: 'xpg_casino.configuration.operator_id' }, { label: 'Private key', type: 'c-input', path: 'xpg_casino.configuration.private_key' }, { label: 'Lobby url', type: 'c-input', path: 'xpg_casino.configuration.lobby_url' }]
  }, {
    label: 'Ezugi Casino',
    path: 'ezugi',
    enabledPath: 'ezugi.enabled',
    fields: [{ label: 'Operator id', type: 'c-input', path: 'ezugi.configuration.operator_id' }, { label: 'Name', type: 'c-input', path: 'ezugi.configuration.name' }, { label: 'Private Key', type: 'c-input', path: 'ezugi.configuration.private_key' }, { label: 'Api URL', type: 'c-input', path: 'ezugi.configuration.api_url' }, { label: 'Lobby url', type: 'c-input', path: 'ezugi.configuration.lobby_url' }, { label: 'Language', type: 'c-select', path: 'ezugi.configuration.language' }]
  }, {
    label: 'Inout',
    path: 'inout',
    enabledPath: 'inout.enabled',
    fields: [{ label: 'Operator id', type: 'c-input', path: 'inout.configuration.operator_id' }, { label: 'Name', type: 'c-input', path: 'inout.configuration.name' }, { label: 'Private Key', type: 'c-input', path: 'inout.configuration.private_key' }, { label: 'Api URL', type: 'c-input', path: 'inout.configuration.api_url' }, { label: 'Lobby url', type: 'c-input', path: 'inout.configuration.lobby_url' }, { label: 'Language', type: 'c-select', path: 'inout.configuration.language' }, { label: 'Country Code', type: 'c-input', path: 'inout.configuration.country_code' }]
  }]
}, {
  label: 'Bets',
  path: 'bets',
  fields: [{
    label: 'One click betting',
    fields: [{ label: 'Enabled', type: 'b-switch', path: 'frontConfiguration.data.oneClickBetting.enabled' }, { label: 'Default Bet Values', type: 'c-tag-input', path: 'bet.configuration.default_bet_values' }]
  }, {
    label: 'Post Affiliate Pro',
    fields: [{ label: 'Enabled', type: 'c-switch', path: 'bet.configuration.post_affiliate_pro.enabled' }, { label: 'Merchant ID', type: 'c-input', path: 'bet.configuration.post_affiliate_pro.merchant_id' }, { label: 'Api Host', type: 'c-input', path: 'bet.configuration.post_affiliate_pro.api_host' }, {
      label: 'Commission Percent',
      type: 'c-input',
      path: 'bet.configuration.post_affiliate_pro.commissionPercent'
    }]
  }]
}, {
  label: 'User',
  path: 'user',
  children: [{
    label: 'Settings',
    path: 'settings',
    fields: [{ label: 'Licence', type: 'c-select', path: 'user.configuration.license' }, { label: 'Resetting TTL', type: 'c-input', path: 'user.configuration.ttl' }, { label: 'Risk Score', type: 'c-input', path: 'user.configuration.risk_score' }, { label: 'Auto login', type: 'c-switch', path: 'user.configuration.auto_login' }, { label: 'Unique Phone', type: 'c-switch', path: 'user.configuration.unique_phone' }, { label: 'TFA', type: 'c-switch', path: 'user.configuration.tfa' }, { label: 'Limit Payments', type: 'b-switch', path: 'frontConfiguration.data.show_all_payments' }, { label: 'Enabled Tracking', type: 'c-switch', path: 'user.configuration.is_tracking_enabled' }, { label: 'Login Required', type: 'b-switch', path: 'frontConfiguration.data.login.required' }, { label: 'Registration Status', type: 'c-select', path: 'user.configuration.registration_status' }, {
      type: 'frontend-registration-type',
      path: 'frontConfiguration.data.registration.type'
    }, {
      type: 'frontend-registration-password-strength',
      path: 'frontConfiguration.data.registration.passwordStrength'
    }, {
      label: 'Login Terms Check',
      type: 'b-switch',
      path: 'frontConfiguration.data.login.termsCheck'
    }, {
      label: 'Responsible Gambling',
      type: 'b-switch',
      path: 'frontConfiguration.data.responsibleGambling'
    }, {
      label: 'Display Currency',
      type: 'b-switch',
      path: 'frontConfiguration.data.displayCurrency'
    }, {
      label: 'Leaderboard',
      type: 'c-switch',
      path: 'user.configuration.leaderboard'
    }, {
      label: 'Fields',
      type: 'user-fields',
      path: 'frontConfiguration.data.user.fields'
    }]
  }, {
    label: 'Permissions',
    path: 'permissions',
    fields: [{
      type: 'user-permissions',
      path: 'frontConfiguration.data.permissions'
    }]
  }, {
    label: 'Recaptcha',
    path: 'recaptcha',
    enabledPath: 'user.configuration.recaptcha.enabled',
    fields: [{ label: 'Secret', type: 'c-input', path: 'user.configuration.recaptcha.secret' }, { label: 'On Login(front)', type: 'b-switch', path: 'frontConfiguration.data.recaptcha.on_login' }, {
      label: 'On Register(front)',
      type: 'b-switch',
      path: 'frontConfiguration.data.recaptcha.on_register'
    }, { label: 'On Login(back)', type: 'c-switch', path: 'user.configuration.recaptcha.on_login' }, { label: 'On Register(back)', type: 'c-switch', path: 'user.configuration.recaptcha.on_register' }, { label: 'Site key', type: 'c-input', path: 'frontConfiguration.data.recaptcha.site_key' }]
  }, {
    label: 'Verification',
    path: 'verification',
    fields: [{
      label: 'Enabled',
      type: 'c-multi-select',
      path: 'user.configuration.verification.enabled'
    }, {
      label: 'Rules',
      type: 'user-verification',
      path: 'user.configuration.verification.result',
      payload: {
        enabled: 'user.configuration.verification.enabled'
      }
    }, {
      label: 'Notification',
      type: 'b-switch',
      path: 'frontConfiguration.data.verification.notification'
    }, {
      label: 'W2 Global',
      fields: [{
        label: 'Api Key',
        type: 'c-input',
        path: 'user.configuration.verification.w2_global.api_key'
      }, {
        label: 'Is Sandbox',
        type: 'c-switch',
        path: 'user.configuration.verification.w2_global.is_sandbox'
      }]
    }, {
      label: 'Gam Stop',
      fields: [{
        label: 'Api Key',
        type: 'c-input',
        path: 'user.configuration.verification.gam_stop.api_key'
      }, {
        label: 'Operator Id',
        type: 'c-input',
        path: 'user.configuration.verification.gam_stop.operator_id'
      }, {
        label: 'Url',
        type: 'c-input',
        path: 'user.configuration.verification.gam_stop.url'
      }]
    }, {
      label: 'Neverbounce',
      fields: [{
        label: 'Api Key',
        type: 'c-input',
        path: 'user.configuration.verification.never_bounce.api_key'
      }, {
        label: 'Frontend Api Key',
        type: 'b-input',
        path: 'frontConfiguration.data.neverBounce.apiKey'
      }, {
        label: 'Url',
        type: 'c-input',
        path: 'user.configuration.verification.never_bounce.url'
      }]
    }]
  }, {
    label: 'JWT',
    path: 'jwt',
    fields: [{ label: 'Secret', type: 'c-input', path: 'user.configuration.jwt.secret' }, { label: 'TTL', type: 'c-input', path: 'user.configuration.jwt.ttl' }]
  }, {
    label: 'Firebase',
    path: 'firebase',
    enabledPath: 'core.configuration.firebase.enabled',
    fields: [{ label: 'Project ID', type: 'c-input', path: 'core.configuration.firebase.project_id' }, { label: 'Client ID', type: 'c-input', path: 'core.configuration.firebase.client_id' }, { label: 'Client Email', type: 'c-input', path: 'core.configuration.firebase.client_email' }, { label: 'Private Key', type: 'c-input', path: 'core.configuration.firebase.private_key' }]
  }, {
    label: 'Bonus',
    path: 'bonus',
    enabledPath: 'bonus.enabled',
    fields: [{
      label: 'Dust thresholds (per currency, "default" required)',
      type: 'bonus-currency-map',
      valueType: 'dust',
      path: 'bonus.configuration.dust_threshold'
    }, {
      label: 'Dust grace (s)',
      type: 'c-input',
      valueType: 'integer',
      path: 'bonus.configuration.dust_grace_seconds'
    }]
  }, { label: 'Bookmaker', path: 'bookmaker', enabledPath: 'account.configuration.bookmaker.enabled' }, {
    label: 'Balance suspend enabled',
    path: 'balance_suspend_enabled',
    enabledPath: 'account.configuration.balance_suspend_enabled.enabled'
  }, {
    label: 'Balance Suspend Limit',
    path: 'balance_suspend_limit',
    fields: [{
      label: 'Balance suspend limit',
      type: 'c-input',
      path: 'account.configuration.balance_suspend_limit'
    }, {
      label: 'Balance suspend enabled front',
      type: 'b-switch',
      path: 'frontConfiguration.data.balance_suspend_limit_enabled'
    }]
  }, { label: 'Constraint', path: 'constraint', enabledPath: 'constraint.enabled' }, {
    label: 'Telegram',
    path: 'telegram',
    enabledPath: 'user.configuration.telegram.enabled',
    fields: [{ label: 'Token', type: 'c-input', path: 'user.configuration.telegram.token' }]
  }, {
    label: 'Intercom',
    path: 'intercom',
    enabledPath: 'user.configuration.intercom.enabled',
    fields: [{ label: 'App ID', type: 'c-input', path: 'user.configuration.intercom.appId' }, { label: 'Token', type: 'c-input', path: 'user.configuration.intercom.token' }, { label: 'Public App ID', type: 'c-input', path: 'frontConfiguration.data.intercom.publicAppId' }, { type: 'intercom-options', path: 'frontConfiguration.data.intercom.options' }]
  }, {
    label: 'Income Access',
    path: 'income-access',
    enabledPath: 'user.configuration.incomeAccess.enabled',
    fields: [{ label: 'Host', type: 'c-input', path: 'user.configuration.incomeAccess.host' }, { label: 'Merchant', type: 'c-input', path: 'user.configuration.incomeAccess.merchant' }, { label: 'Password', type: 'c-input', path: 'user.configuration.incomeAccess.password' }, {
      label: 'Registration Path',
      type: 'c-input',
      path: 'user.configuration.incomeAccess.registrationPath'
    }, { label: 'Sales Path', type: 'c-input', path: 'user.configuration.incomeAccess.salesPath' }, { label: 'Username', type: 'c-input', path: 'user.configuration.incomeAccess.username' }]
  }, {
    label: 'Partner Matrix',
    path: 'partner-matrix',
    enabledPath: 'user.configuration.partnerMatrix.enabled',
    fields: [{ label: 'Host', type: 'c-input', path: 'user.configuration.partnerMatrix.host' }, { label: 'Merchant', type: 'c-input', path: 'user.configuration.partnerMatrix.merchant' }, { label: 'Password', type: 'c-input', path: 'user.configuration.partnerMatrix.password' }, {
      label: 'Registration Path',
      type: 'c-input',
      path: 'user.configuration.partnerMatrix.registrationPath'
    }, { label: 'Sales Path', type: 'c-input', path: 'user.configuration.partnerMatrix.salesPath' }, { label: 'Username', type: 'c-input', path: 'user.configuration.partnerMatrix.username' }, {
      label: 'Commission Percent',
      fields: [{
        label: 'betfair',
        type: 'c-input',
        path: 'user.configuration.partnerMatrix.commissionPercent.betfair'
      }, {
        label: 'sportsbook',
        type: 'c-input',
        path: 'user.configuration.partnerMatrix.commissionPercent.sportsbook'
      }, {
        label: 'casino',
        type: 'c-input',
        path: 'user.configuration.partnerMatrix.commissionPercent.casino'
      }]
    }]
  }, {
    label: 'Dosta',
    path: 'dosta',
    enabledPath: 'user.configuration.dosta.enabled',
    fields: [{ label: 'Host', type: 'c-input', path: 'user.configuration.dosta.host' }, { label: 'Username', type: 'c-input', path: 'user.configuration.dosta.username' }, { label: 'Password', type: 'c-input', path: 'user.configuration.dosta.password' }, { label: 'Merchant', type: 'c-input', path: 'user.configuration.dosta.merchant' }, {
      label: 'Failed Transactions',
      type: 'c-switch',
      path: 'user.configuration.dosta.failedTransactionsEnabled'
    }, {
      label: 'Failed Transactions Path',
      type: 'c-input',
      path: 'user.configuration.dosta.failedTransactionsPath'
    }, {
      label: 'Betting Users',
      type: 'c-switch',
      path: 'user.configuration.dosta.usersEnabled'
    }, {
      label: 'Betting Users Path',
      type: 'c-input',
      path: 'user.configuration.dosta.bettingUsersPath'
    }]
  }, {
    label: 'Facebook',
    path: 'facebook',
    enabledPath: 'user.configuration.facebook.enabled',
    fields: [{ label: 'ClientId', type: 'c-input', path: 'user.configuration.facebook.clientId' }, { label: 'Secret', type: 'c-input', path: 'user.configuration.facebook.secret' }]
  }, {
    label: 'Twitch',
    path: 'twitch',
    enabledPath: 'user.configuration.twitch.enabled',
    fields: [{ label: 'ClientId', type: 'c-input', path: 'user.configuration.twitch.clientId' }, { label: 'Secret', type: 'c-input', path: 'user.configuration.twitch.secret' }]
  }, {
    label: 'Admin PT',
    path: 'pt',
    fields: [{ label: 'Admin PT', type: 'c-input', path: 'account.configuration.pt.data' }]
  }, {
    label: 'Money Transfer',
    path: 'money-transfer',
    fields: [{ label: 'Enabled', type: 'b-switch', path: 'frontConfiguration.data.moneyTransfer.enabled' }]
  }]
}, {
  label: 'Services',
  path: 'services',
  children: [{
    label: 'File Manager',
    path: 'file-manager',
    fields: [{ type: 'file-manager', path: 'core.configuration.file_manager' }]
  }, {
    label: 'Graylog',
    path: 'graylog',
    enabledPath: 'core.configuration.graylog.enabled',
    fields: [{ label: 'Host', type: 'c-input', path: 'core.configuration.graylog.host' }, { label: 'Port', type: 'c-input', path: 'core.configuration.graylog.port' }, { label: 'Source', type: 'c-input', path: 'core.configuration.graylog.source' }]
  }, {
    label: 'Audit Log',
    path: 'audit-log',
    enabledPath: 'core.configuration.audit_log.enabled',
    fields: [{ label: 'Api Key', type: 'c-input', path: 'core.configuration.audit_log.api_key' }, { label: 'Host', type: 'c-input', path: 'core.configuration.audit_log.host' }, { label: 'Port', type: 'c-input', path: 'core.configuration.audit_log.port' }, { label: 'Username', type: 'c-input', path: 'core.configuration.audit_log.username' }, { label: 'Password', type: 'c-input', path: 'core.configuration.audit_log.password' }]
  }, {
    label: 'Contact Us',
    path: 'contact-us',
    enabledPath: 'contact_us.enabled',
    fields: [{ label: 'Email', type: 'c-input', path: 'contact_us.configuration.email' }]
  }, {
    label: 'Notifications',
    path: 'notifications',
    fields: [{ label: 'Email', type: 'c-input', path: 'core.configuration.message.email' }, { label: 'Name', type: 'c-input', path: 'core.configuration.message.name' }, { label: 'Jira Host', type: 'c-input', path: 'core.configuration.message.jiraHost' }, { label: 'Jira User', type: 'c-input', path: 'core.configuration.message.jiraUser' }, { label: 'jira Api Token', type: 'c-input', path: 'core.configuration.message.jiraApiToken' }, { label: 'Jira Project Key', type: 'c-input', path: 'core.configuration.message.jiraProjectKey' }]
  }, {
    label: 'Slack',
    path: 'slack',
    enabledPath: 'core.configuration.slack.enabled',
    fields: [{ label: 'Channel', type: 'c-input', path: 'core.configuration.slack.channel' }, { label: 'Max Bet Amount', type: 'c-input', path: 'core.configuration.slack.max_bet_amount' }, { label: 'Token', type: 'c-input', path: 'core.configuration.slack.token' }]
  }]
}, {
  label: 'Widgets',
  path: 'widgets',
  children: [{
    label: 'Match progress',
    path: 'match-progress',
    fields: [{ label: 'Token', type: 'c-input', path: 'frontConfiguration.data.widgets.matchProgress' }]
  }]
}]);

function getExchangeSettings(exchangeType) {
  return [{
    label: 'Bet Submit Delay (ms)',
    type: 'c-input',
    valueType: 'integer',
    path: 'frontConfiguration.data.' + exchangeType + '.betslip.submitDelay'
  }, {
    label: 'Route namespace',
    type: 'b-input',
    path: 'frontConfiguration.data.' + exchangeType + '.prefixUrl'
  }, {
    label: 'Prelive enabled',
    type: 'b-switch',
    path: 'frontConfiguration.data.' + exchangeType + '.prelive.enabled'
  }, {
    label: 'Prelive title',
    type: 'b-input',
    path: 'frontConfiguration.data.' + exchangeType + '.prelive.title'
  }, {
    label: 'Live enabled',
    type: 'b-switch',
    path: 'frontConfiguration.data.' + exchangeType + '.live.enabled'
  }, {
    label: 'Live title',
    type: 'b-input',
    path: 'frontConfiguration.data.' + exchangeType + '.live.title'
  }];
}

/***/ }),

/***/ "qPFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = migrate;
/* unused harmony export updateStructure */
/* unused harmony export updateData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonpatch__ = __webpack_require__("+byF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonpatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonpatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Schema_json__ = __webpack_require__("U3SS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Schema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Schema_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__migrations_mjs__ = __webpack_require__("4WnI");





function migrate(frontendData, stage, name) {
  var copiedData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, frontendData || {});
  var isUpToDate = __WEBPACK_IMPORTED_MODULE_2__Schema_json___default.a.version <= copiedData.version;
  var nextVersion = copiedData.version && copiedData.version + 1 || 1;

  if (!isUpToDate) {
    for (nextVersion; nextVersion <= __WEBPACK_IMPORTED_MODULE_2__Schema_json___default.a.version; nextVersion += 1) {
      var tempData = updateStructure(nextVersion, copiedData);
      copiedData = updateData(nextVersion, tempData, stage, name);
    }
  }

  return { isUpToDate: isUpToDate, data: copiedData };
}

function updateStructure(version, data) {
  if (!__WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version]) throw new Error('Structure update failed');

  var migration = __WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version].migration.concat({
    op: 'replace',
    path: '/version',
    value: version
  });

  return __WEBPACK_IMPORTED_MODULE_1_jsonpatch___default.a.apply_patch(data, migration);
}

function updateData(version, data, stage, name) {
  if (!__WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version]) throw new Error('Data update failed');

  if (!__WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version].update) {
    return data;
  }

  return __WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version].update && __WEBPACK_IMPORTED_MODULE_3__migrations_mjs__["a" /* default */][version].update(data, stage, name);
}

/***/ }),

/***/ "qoLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationType_vue__ = __webpack_require__("FRx0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab311b9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationType_vue__ = __webpack_require__("RQ4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab311b9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationType_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab311b9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationType_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r0Jc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"project-form"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('section',[_c('b-field',{attrs:{"label":"Name"}},[_c('b-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('input',{staticClass:"button",attrs:{"type":"submit","value":"Save"}}),_vm._v(" "),_c('router-link',{staticClass:"button submit",attrs:{"to":"/payment_methods"}},[_vm._v("Back")])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "rEWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserVerification_vue__ = __webpack_require__("nZQN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5faa454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserVerification_vue__ = __webpack_require__("SQlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserVerification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5faa454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserVerification_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5faa454_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserVerification_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rzh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function getOrigin() {
  if (window.location.hostname === 'localhost') {
    return "http://configurator.bettings.ch/api";
  } else {
    return window.location.origin + '/api';
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: getOrigin(),
  withCredentials: true,
  params: {
    secret_key: '12389FJAF8u0ufjsHHK3010283019SFAC'
  }
}));

/***/ }),

/***/ "s4QH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.valueIsObj)?_c('b-input',{model:{value:(_vm.value.data),callback:function ($$v) {_vm.$set(_vm.value, "data", $$v)},expression:"value.data"}}):_c('b-input',{attrs:{"value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "sr/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuplicateForm__ = __webpack_require__("9zY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_components_Empty__ = __webpack_require__("gGau");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      projects: [],
      loading: false,
      q: '',
      togglingProjectId: null,
      duplicatedProjectId: null,
      isDuplicateModalOpened: false
    };
  },

  components: {
    DuplicateForm: __WEBPACK_IMPORTED_MODULE_1__DuplicateForm__["a" /* default */],
    Empty: __WEBPACK_IMPORTED_MODULE_3__lib_components_Empty__["a" /* default */]
  },
  mounted: function mounted() {
    if (localStorage.projects) {
      this.projects = JSON.parse(localStorage.projects);
    }
  },

  computed: {
    filteredProjects: function filteredProjects() {
      var _this = this;

      return this.projects.filter(function (p) {
        return p.name.includes(_this.q) || p.domain.some(function (p) {
          return p.includes(_this.q);
        });
      }).sort(function (a, b) {
        return b.id - a.id;
      });
    }
  },
  methods: {
    flushCache: function flushCache(domain) {
      var one = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=1&config=Ed[MDB7X!MZn}Zd&type=main');
      var two = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=2&config=Ed[MDB7X!MZn}Zd');
      var three = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=3&config=Ed[MDB7X!MZn}Zd');
      var loader = this.$loading.open();
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.all([one, two, three]).then(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.spread(function () {
        var responseOne = arguments.length <= 0 ? undefined : arguments[0];
        var responseTwo = arguments.length <= 1 ? undefined : arguments[1];
        var responesThree = arguments.length <= 2 ? undefined : arguments[2];
        loader.close();
      })).catch(function (e) {
        loader.close();
      });
    },
    flushGameCache: function flushGameCache(domain) {
      var one = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=1&config=Ed[MDB7X!MZn}Zd&type=games');
      var two = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=2&config=Ed[MDB7X!MZn}Zd');
      var three = __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get(domain + '/init?s=3&config=Ed[MDB7X!MZn}Zd');
      var loader = this.$loading.open();
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.all([one, two, three]).then(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.spread(function () {
        var responseOne = arguments.length <= 0 ? undefined : arguments[0];
        var responseTwo = arguments.length <= 1 ? undefined : arguments[1];
        var responesThree = arguments.length <= 2 ? undefined : arguments[2];
        loader.close();
      })).catch(function (e) {
        loader.close();
      });
    },
    create: function create() {
      this.$router.push('/projects/new');
    },
    load: function load() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var projects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].get('projects', { params: { page: page } }).then(function (resp) {
        if (resp.data.length > 0) {
          projects = projects.concat(resp.data);
        }
        if (resp.data.length === 30) {
          _this2.load(page + 1, projects);
        } else {
          _this2.save(projects);
        }
      }).catch(function () {
        _this2.save(projects);
      });
    },
    save: function save(projects) {
      this.projects = projects;
      localStorage.projects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(projects);
    },
    toggleEnable: function toggleEnable(projectId) {
      var _this3 = this;

      if (this.togglingProjectId) return;

      var project = this.projects.find(function (p) {
        return p.id === projectId;
      });
      if (!project) return;

      var action = project.enabled ? 'disable' : 'enable';
      this.togglingProjectId = projectId;

      __WEBPACK_IMPORTED_MODULE_2__lib_utils_http__["a" /* default */].put('projects/' + projectId + '/' + action).then(function (resp) {
        return project.enabled = resp.data.enabled;
      }).catch(function () {}).then(function () {
        return _this3.togglingProjectId = null;
      });
    },
    toggleDuplicateModal: function toggleDuplicateModal(projectId) {
      this.isDuplicateModalOpened = true;
      this.duplicatedProjectId = projectId;
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "u/OH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__ = __webpack_require__("ElPh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c5cb16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__ = __webpack_require__("s4QH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c5cb16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c5cb16_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uSoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taginput',{attrs:{"icon":"tag","placeholder":"Enter value"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []


/***/ }),

/***/ "uWZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_components_Input__ = __webpack_require__("u/OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_components_Select__ = __webpack_require__("dkO4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'file-manager',
  props: ['value', 'fieldErrors'],
  components: {
    CInput: __WEBPACK_IMPORTED_MODULE_0__lib_components_Input__["a" /* default */],
    CSelect: __WEBPACK_IMPORTED_MODULE_1__lib_components_Select__["a" /* default */]
  }
});

/***/ }),

/***/ "vjwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__ = __webpack_require__("rzh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__ = __webpack_require__("8XDQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'duplicate-form',
  props: ['projectId'],
  data: function data() {
    return {
      form: {
        name: '',
        mainDomain: ''
      }
    };
  },

  methods: {
    duplicate: function duplicate() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__lib_utils_http__["a" /* default */].post('projects/' + this.projectId + '/duplicate', this.form).then(function (resp) {
        _this.$router.push('projects/' + resp.data.id + '/edit');
        _this.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["b" /* success */])());
      }).catch(function () {
        _this.$toast.open(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_toast__["a" /* error */])());
      });
    }
  }
});

/***/ }),

/***/ "vsZp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wlpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fields_vue__ = __webpack_require__("6BGe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f99a72e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fields_vue__ = __webpack_require__("CHsd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("x3d3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f99a72e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fields_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f99a72e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fields_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wv8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._l((_vm.data),function(provider,index){return _c('div',{key:index,staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Live","horizontal":""}},[_c('b-input',{model:{value:(provider.live.source),callback:function ($$v) {_vm.$set(provider.live, "source", $$v)},expression:"provider.live.source"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Prelive","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.source),callback:function ($$v) {_vm.$set(provider.prelive, "source", $$v)},expression:"provider.prelive.source"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Url","horizontal":""}},[_c('b-input',{model:{value:(provider.live.url),callback:function ($$v) {_vm.$set(provider.live, "url", $$v)},expression:"provider.live.url"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Url","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.url),callback:function ($$v) {_vm.$set(provider.prelive, "url", $$v)},expression:"provider.prelive.url"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Name","horizontal":""}},[_c('b-input',{model:{value:(provider.live.name),callback:function ($$v) {_vm.$set(provider.live, "name", $$v)},expression:"provider.live.name"}})],1),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Name","horizontal":""}},[_c('b-input',{model:{value:(provider.prelive.name),callback:function ($$v) {_vm.$set(provider.prelive, "name", $$v)},expression:"provider.prelive.name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('b-field',{staticClass:"field",attrs:{"label":"Types","horizontal":""}},[_c('section',{staticClass:"checkbox-list"},_vm._l((_vm.types),function(value){return _c('b-checkbox',{key:value,attrs:{"native-value":value},model:{value:(provider.live.types),callback:function ($$v) {_vm.$set(provider.live, "types", $$v)},expression:"provider.live.types"}},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}))]),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"label":"Types","horizontal":""}},[_c('section',{staticClass:"checkbox-list"},_vm._l((_vm.types),function(value){return _c('b-checkbox',{key:value,attrs:{"native-value":value},model:{value:(provider.prelive.types),callback:function ($$v) {_vm.$set(provider.prelive, "types", $$v)},expression:"provider.prelive.types"}},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}))])],1),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.removeSource(index)}}},[_c('b-icon',{attrs:{"icon":"minus"}})],1)])])}),_vm._v(" "),_c('b-field',{staticClass:"field",attrs:{"horizontal":""}},[_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":_vm.addSource}},[_vm._v("\n      Add source\n    ")])])],2)}
var staticRenderFns = []


/***/ }),

/***/ "wwRg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x3d3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Password Strength","horizontal":""}},[_c('b-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.choices),function(choice){return _c('option',{key:choice,domProps:{"value":choice}},[_vm._v(_vm._s(choice))])}))],1)}
var staticRenderFns = []


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      burger: false
    };
  }
});

/***/ }),

/***/ "xPB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Options","horizontal":""}},[_c('div',{staticClass:"block"},[_c('b-checkbox',{attrs:{"native-value":"bets"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_vm._v("Bets")]),_vm._v(" "),_c('b-checkbox',{attrs:{"native-value":"transactions"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_vm._v("Transactions")])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "y/lZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserFields_vue__ = __webpack_require__("KKHi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce2ab01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserFields_vue__ = __webpack_require__("GOdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce2ab01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserFields_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce2ab01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserFields_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zOiR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.63166058d80f6430b6a3.js